import moment from "moment";
import Modal from '@mui/material/Modal';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import { LockOutlined } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import ListItemText from '@mui/material/ListItemText';
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { AppMode } from "../../../env";
import SidebarIndex from "./SidebarIndexOld";
import Pill from "../../../components/common/Pill";
import IDeals from "../../../components/svgs/IDeals";
import Dropbox from "../../../components/svgs/Dropbox";
import Button from "../../../components/common/Button";
import Datasite from "../../../components/svgs/Datasite";
import { hasAllDataRepoPermission } from "../../../utils";
import { toggleModal } from "../../../reducers/modalReducer";
import SharePoint from "../../../components/svgs/SharePoint";
import SeedLegals from "../../../components/svgs/SeedLegals";
import GoogleDrive from "../../../components/svgs/GoogleDrive";
import CloseBtn from "../../../../images/dataRepo/closebtn.svg";
import DeduperReport from "../../../components/modals/deduperReport";
import { setDataroomConfig } from "../../../reducers/dataRoomReducer";
import socket, { getRequest, postRequest, showMessage } from '../../../config';
import FileReportHistory from "../../../components/modals/fileReportHistory";
import AuditLogModal from "../../../components/modals/auditLog/auditLogModal";
import UnallocatedFilesModal from "../../../components/modals/unallocateFiles";
import DisconnectDataroom from "../../../components/modals/disconnectDataroom";
import HeadingSubheadingContent from "../../../components/HeadingSubheadingContent";
import { setDeduperFiles, setUnallocatedFiles } from "../../../reducers/filesReducer";
import { hasNotAllTheDataRepositoryPermissions } from "../../../utils";
import ManageFilesModal from "../../../components/modals/dataRepository/manageFilesModal";
import DeduperReportWaiting from "../../../components/modals/deduperReport/deduperReportWaiting";
import WelcomToDashboardModal from "../../../components/modals/dataRepository/welcomToDashboardModal";
import UserDefinedSectionModal from "../../../components/modals/dataRepository/userDefinedSectionModal";
import DeleteFileConfirmModal from "../../../components/modals/deleteFileConfirm/deleteFileConfirmModal";
import { setLogList, setRModalData, setOpenRModal, setTargetSection, updateFileAllocation } from "../../../reducers/filesAllocationReducer";
import WarrantyDisclosureManageFilesModal from "../../../components/modals/warrantyDisclosure/warrantyDisclosureManageFilesModal";
import debounce from "lodash.debounce";
import "../../../../styles/rsuite.change.css";
import 'react-circular-progressbar/dist/styles.css';
import ConnectDataroomModal from "../../../components/modals/ConnectDataroomModal";
import { findAndUpdateReSyncing, findAndUpdateSyncing, resetReSyncing, resetSyncing, startReSyncing, startSyncing, startSyncingFolders, syncingFoldersComplete } from "../../../reducers/fileManagementReducer";
import DisclaimerModal from "../../../components/modals/disclaimer";
import ModalWrapper from "../../../components/common/Modal/ModalWrapper";
import { useNavigate } from "react-router-dom";
import { AutoFillButton } from "../../../components/autoFill";
import WorkflowNotesModal from "./NewDashboard/QuestionAnswersPage/components/WorkflowNotesModal";

const INSURANCE_REPORT_LOADING_STORAGE_KEY = 'insuranceReportGenerationStatus';
const AI_REPORT_DISCLAIMER_KEY = 'isAgreeWithAIReportDisclaimer';

const canUseBrowserStorage = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const readJsonFromStorage = (key, fallbackValue) => {
	if (!canUseBrowserStorage()) return fallbackValue;
	try {
		const rawValue = window.localStorage.getItem(key);
		if (!rawValue) return fallbackValue;
		const parsedValue = JSON.parse(rawValue);
		return parsedValue ?? fallbackValue;
	} catch (error) {
		return fallbackValue;
	}
};

const writeJsonToStorage = (key, value) => {
	if (!canUseBrowserStorage()) return;
	try {
		window.localStorage.setItem(key, JSON.stringify(value));
	} catch (error) {
		// Ignore storage write failures (quota exceeded, private mode, etc.)
	}
};

const getPersistedReportLoadingMap = () => {
	const stored = readJsonFromStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, {});
	if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
		writeJsonToStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, {});
		return {};
	}
	return stored;
};

const getAiReportDisclaimerAgreements = () => {
	const stored = readJsonFromStorage(AI_REPORT_DISCLAIMER_KEY, []);
	if (!Array.isArray(stored)) {
		writeJsonToStorage(AI_REPORT_DISCLAIMER_KEY, []);
		return [];
	}
	return stored;
};


export default function QuesAns({ isManualAdd, getCompany, setIsWorkflowReport, profileClass, advisors, permissionLevel, tab, setTab, sanitiseTab, company, setCompany, companyId, openKPI, toggleReport, enableAIEnhancedReporting, calculateStats, calculateSubFolderStats,
	getCompletenessAndRiskHTML, aiEnhanced, setAiEnchaned, reloadModule, twoMinuteTestAIReport, getFitInvestorFirms, isTwoMinuteTesHomePage, setOpenTabs, openTabs, companyIndex, setCompanyDashboardTab, setCloneImportResult, setCurrentScore,
	reportHistories, setReportHistories, setFileReport, sortSections, showAlert, handleSuperflowNext, setTabName, closeTab, isBackFitReport, setIsBackFitReport, isLoader, setIsLoader }) {

	let dispatch = useDispatch();
	const navigate = useNavigate();
	const spinner = document.getElementById("e1jygW4piZH1");
	let user = useSelector(state => state.user);
	let modal = useSelector(state => state.modal);
	let { syncing } = useSelector((state) => state.appData);
	let { logList, targetSection, processing } = useSelector(state => state.fileAllocation);

	let { unallocatedFiles, deduperReports: dupCheck } = useSelector(state => state.files);

	// Reload module data when auto-fill completes so answers appear without page refresh
	useEffect(() => {
		if (!modal.autoFillJustCompleted) return;
		dispatch(toggleModal({ autoFillJustCompleted: false }));
		if (tab && reloadModule) reloadModule(tab);
	}, [modal.autoFillJustCompleted]); // eslint-disable-line react-hooks/exhaustive-deps

	const companyObjectId = company?._id;
	const reportGenerationRequestRef = useRef(null);
	const lastReportAnchorRef = useRef(null); // Stores anchor to scroll when closing report
	const isComponentMountedRef = useRef(false);
	// Helper function to generate unique key for section/question
	const getReportGenerationKey = (data, isQuestion) => {
		if (isQuestion) {
			// For questions: use sectionId + questionId or qNo
			const sectionId = data?.sectionId || data?.section?._id;
			const questionId = data?._id || data?.qNo;
			return `question-${sectionId}-${questionId}`;
		} else {
			// For sections: use sectionId
			const sectionId = data?._id || data?.section?._id;
			return `section-${sectionId}`;
		}
	};

	const [reportGenerateLoading, setReportGenerateLoadingState] = useState(() => {
		if (!companyObjectId) return null;
		const loadingMap = getPersistedReportLoadingMap();
		const entry = loadingMap[companyObjectId];
		if (entry && entry.status === 'pending') {
			reportGenerationRequestRef.current = entry.requestId || null;
			return entry.generatingKey || null;
		}
		return null;
	});
	const [agreedAiReportDisclaimerIds, setAgreedAiReportDisclaimerIds] = useState(() => getAiReportDisclaimerAgreements());
	const hasAgreedAiReportDisclaimer = companyObjectId ? agreedAiReportDisclaimerIds.includes(companyObjectId) : false;
	let [section, setSection] = useState();
	let [refresh, setRefresh] = useState(false);
	let [loading, setLoading] = useState(false);
	let [logModule, setLogModule] = useState([]);
	let [deleteFile, setDeleteFile] = useState();
	let [isSaving, setIsSaving] = useState(false);
	let [saveTimeout, setSaveTimeout] = useState();
	let [attachment, setAttachment] = useState([]);
	let [visibleSection, setVisibleSection] = useState(null);
	let [isFAMenuVisible, setFAMenuVisible] = useState(false);
	let [newUpgradeSync, setNewUpgradeSync] = useState(false);
	let [deleteFileLoading, setDeleteFileLoading] = useState(false);
	let [deleteFileQuestionId, setDeleteFileQuestionId] = useState();
	let [deleteUnallocatedFile, setDeleteUnallocatedFile] = useState();
	let [questionsAndAnswersToSave, setQuestionsAndAnswersToSave] = useState([]);
	const [dateValue, setDateValue] = useState({});
	const location = useLocation();
	const [dataRoomMenuVisible, setDataRoomMenuVisible] = useState(true);
	const [filingAssistantSubmenuHover, setFilingAssistantSubmenuHover] = useState(false);
	const [openToolboxes, setOpenToolboxes] = useState({});
	const [workflowModalData, setWorkflowModalData] = useState(null);
	const [uploadOpenMap, setUploadOpenMap] = useState({});
	const toggleToolbox = useCallback((questionId) => {
		setOpenToolboxes(prev => ({ ...prev, [questionId]: prev[questionId] !== true }));
	}, []);

	useEffect(() => {
		const isMember = company['members']?.some(member => member._id === user._id) || company?.['advisors']?.[user._id];
		const hasAllPermissions = company ? hasAllDataRepoPermission(company?.['memberPermissions']?.[user._id]) || hasAllDataRepoPermission(company?.['advisors']?.[user._id]?.['modules']) : false;
		const isInvestorOwner = company?.['investors'] && Object.keys(company['investors']).length > 0 && company['investors'][user._id] && hasAllDataRepoPermission(company?.['investors']?.[user._id]?.['modules']);
		if (((!company?.isParent && company['owners'][0] === user._id) || (company?.isParent && company['owners'][0] === user._id) || (((company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id)) || (isMember && hasAllPermissions) || isInvestorOwner)) {
			setDataRoomMenuVisible(true);
		} else {
			setDataRoomMenuVisible(false);
		}
	}, [company]);
	// State to track which section to navigate to after disclaimer
	const [sectionToNavigate, setSectionToNavigate] = useState(null);
	// Ref to track section navigation to avoid stale closures in callbacks
	const sectionToNavigateRef = useRef(null);
	// Store the expected reportType after generation to find it after refetch
	const expectedReportTypeRef = useRef(null);

	// Helper function to sanitize section name for URLs (matches backend logic)
	const sanitizeSectionName = (name) => {
		if (!name) return '';
		return name.toLowerCase()
			.replace(/\s+/g, '-')  // Replace spaces with hyphens
			.replace(/[^a-z0-9-]/g, '')  // Remove special characters
			.replace(/-+/g, '-')  // Replace multiple hyphens with single hyphen
			.replace(/^-|-$/g, '');  // Remove leading/trailing hyphens
	};

	// Helper function to get section tab name
	const getSectionTabName = (section, isQuestion, data) => {
		if (!section) return '';
		const sectionName = section.sectionName || section.name || '';
		const sanitized = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
		return sanitized ? `${sanitized}-section-report` : '';
	};

	// Helper function to check if a section report exists for a given section
	const hasSectionReport = (section, isQuestion, data) => {
		if (!section || !company?.['aiReports']) return false;
		const sectionName = section.sectionName || section.name || '';
		const sanitizedSectionName = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
		if (!sanitizedSectionName) return false;
		const reportType = `sectionReport_${sanitizedSectionName}`;
		return company['aiReports'].some(report =>
			report.reportType === reportType && report?.htmlReport
		);
	};

	// Helper function to get the report data for a section/question
	const getSectionReport = (section, isQuestion, data) => {
		if (!section || !company?.['aiReports']) return null;
		const sectionName = section.no || section.name || '';
		const sanitizedSectionName = isQuestion ? data.qNo : sectionName;
		if (!sanitizedSectionName) return null;
		const reportType = `sectionReport_${sanitizedSectionName}`;
		return company['aiReports'].find(report =>
			report.reportType === reportType && report?.htmlReport
		) || null;
	};

	const debouncedSaveAnswer = useCallback(
		debounce((e, question, qNo) => {
			saveAnswer(e, question, qNo);
		}, 3000),
		[] // ← ensures debounce function is created once
	);


	useEffect(() => {
		socket.on('SyncingStart', (data) => {
			dispatch(startSyncing(data))
		})

		socket.on('SyncingFoldersStart', () => {
			dispatch(startSyncingFolders())
		})

		socket.on('SyncingFoldersComplete', () => {
			dispatch(syncingFoldersComplete())
		})

		socket.on('Syncing', (data) => {
			dispatch(findAndUpdateSyncing(data))
		})

		socket.on('SyncingFilesNotAvailable', (data) => {
			showMessage(`There are currently no files to sync.`)
		})

		socket.on('SyncingComplete', (data) => {
			dispatch(resetSyncing())
			showMessage(`Syncing Process completed.`)
		})

		socket.on('syncingComplete', () => {
			dispatch(resetSyncing())
		})

		socket.on('ReSyncingStart', (data) => {
			dispatch(startReSyncing(data))
		})


		socket.on('ReSyncing', (data) => {
			dispatch(findAndUpdateReSyncing(data))
		})

		socket.on('ReSyncingComplete', () => {
			dispatch(resetReSyncing())
		})
	}, [])

	useEffect(() => {
		isComponentMountedRef.current = true;
		return () => {
			isComponentMountedRef.current = false;
		};
	}, []);

	useEffect(() => {
		if (!companyObjectId) {
			reportGenerationRequestRef.current = null;
			if (isComponentMountedRef.current) {
				setReportGenerateLoadingState(null);
			}
			return;
		}
		const loadingMap = getPersistedReportLoadingMap();
		const entry = loadingMap[companyObjectId];
		reportGenerationRequestRef.current = entry?.requestId || null;
		const generatingKey = entry?.status === 'pending' ? (entry.generatingKey || null) : null;
		if (isComponentMountedRef.current) {
			setReportGenerateLoadingState(prev => {
				// Only update if the value actually changed
				if (prev !== generatingKey) {
					return generatingKey;
				}
				return prev;
			});
		}
	}, [companyObjectId]);

	// Add storage event listener to sync state when localStorage changes (e.g., from other tabs)
	useEffect(() => {
		const handleStorageChange = (e) => {
			if (e.key === INSURANCE_REPORT_LOADING_STORAGE_KEY && companyObjectId) {
				const loadingMap = getPersistedReportLoadingMap();
				const entry = loadingMap[companyObjectId];
				const generatingKey = entry?.status === 'pending' ? (entry.generatingKey || null) : null;
				if (isComponentMountedRef.current) {
					setReportGenerateLoadingState(generatingKey);
					reportGenerationRequestRef.current = entry?.requestId || null;
				}
			}
		};

		window.addEventListener('storage', handleStorageChange);
		return () => {
			window.removeEventListener('storage', handleStorageChange);
		};
	}, [companyObjectId]);

	const startReportGenerationLoading = useCallback((generatingKey) => {
		const requestId = `${companyObjectId || 'company'}-${Date.now()}`;
		const loadingMap = getPersistedReportLoadingMap();
		if (companyObjectId) {
			loadingMap[companyObjectId] = {
				status: 'pending',
				requestId,
				generatingKey: generatingKey || null,
				startedAt: Date.now()
			};
			writeJsonToStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, loadingMap);
		}
		reportGenerationRequestRef.current = requestId;
		if (isComponentMountedRef.current) {
			setReportGenerateLoadingState(generatingKey || null);
		}
		return requestId;
	}, [companyObjectId]);

	const stopReportGenerationLoading = useCallback((requestId, options = {}) => {
		const { force = false } = options;
		const effectiveRequestId = requestId || reportGenerationRequestRef.current;

		const clearComponentState = (matchedRequestId) => {
			if (!matchedRequestId || reportGenerationRequestRef.current === matchedRequestId) {
				reportGenerationRequestRef.current = null;
			}
			if (isComponentMountedRef.current) {
				// Force state update to null
				setReportGenerateLoadingState(null);
			}
		};

		if (!companyObjectId) {
			clearComponentState(effectiveRequestId);
			return;
		}

		const loadingMap = getPersistedReportLoadingMap();
		const entry = loadingMap[companyObjectId];

		if (!entry) {
			// No entry in localStorage, ensure state is cleared
			clearComponentState(effectiveRequestId);
			return;
		}

		const isMatchingRequest = !effectiveRequestId || entry.requestId === effectiveRequestId;
		const entryAgeMs = entry?.startedAt ? Date.now() - entry.startedAt : 0;
		const isStale = entryAgeMs > 5 * 60 * 1000; // 5 minutes fallback

		if (force || isMatchingRequest || isStale) {
			// Clear from localStorage first
			delete loadingMap[companyObjectId];
			writeJsonToStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, loadingMap);
			// Then clear component state
			clearComponentState(entry.requestId);
			// Double-check: verify localStorage was cleared and sync state
			setTimeout(() => {
				if (isComponentMountedRef.current) {
					const verifyMap = getPersistedReportLoadingMap();
					const verifyEntry = verifyMap[companyObjectId];
					if (!verifyEntry || verifyEntry.status !== 'pending') {
						setReportGenerateLoadingState(null);
					}
				}
			}, 100);
			return;
		}
	}, [companyObjectId]);

	const handleAiReportDisclaimerClose = useCallback(async () => {
		dispatch(toggleModal({ open: '' }));
		if (!companyObjectId) return;

		// Save agreement to localStorage first
		const updatedAgreements = [...agreedAiReportDisclaimerIds];
		if (!updatedAgreements.includes(companyObjectId)) {
			updatedAgreements.push(companyObjectId);
			writeJsonToStorage(AI_REPORT_DISCLAIMER_KEY, updatedAgreements);
			setAgreedAiReportDisclaimerIds(updatedAgreements);
		}
		await getCompany('repository', company);
		let sectionTab = null;
		const expectedReportType = expectedReportTypeRef.current;
		let anchorToStore = lastReportAnchorRef.current;

		if (expectedReportType) {
			const sanitizedSectionName = expectedReportType.replace('sectionReport_', '');
			sectionTab = `${sanitizedSectionName}-section-report`;
		}

		// Fallback: Use navigation target to construct tab name (from R button flow)
		if (!sectionTab) {
			const navigationTarget = sectionToNavigateRef.current;
			if (navigationTarget) {
				const { section, isQuestion, data } = navigationTarget;
				sectionTab = getSectionTabName(section, isQuestion, data);
				if (!anchorToStore) {
					anchorToStore = section?.sectionNo || section?.no || data?.sectionNo || data?.qNo || null;
				}
			}
		}

		// Navigate to the tab (following the same pattern as R button)
		if (sectionTab) {
			// Add tab to openTabs set so it appears in the UI
			if (setOpenTabs && openTabs) {
				const newOpenTabs = new Set(openTabs);
				newOpenTabs.add(sectionTab);
				setOpenTabs(newOpenTabs);
			}

			// Persist anchor for scrolling back on close
			if (anchorToStore) {
				lastReportAnchorRef.current = anchorToStore;
				try {
					localStorage.setItem('lastReportAnchor', anchorToStore);
				} catch (_) { /* ignore */ }
			}

			// Set tab and update URL hash (using proper routing like R button does)
			await setTab(sectionTab);
			// Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
			// Use history.replaceState to ensure the hash persists without triggering navigation
			setTimeout(() => {
				const hashValue = `#${sectionTab}`;
				if (window.location.hash !== hashValue) {
					window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
				}
			}, 100);

			// Clear refs after successful navigation
			expectedReportTypeRef.current = null;
			setSectionToNavigate(null);
			sectionToNavigateRef.current = null;
		}
	}, [companyObjectId, dispatch, setTab, getSectionTabName, company, navigate, getCompany, agreedAiReportDisclaimerIds, setOpenTabs, openTabs]);

	const handleSectionReportLinkClick = useCallback((event, section, isQuestion = false, data = null) => {
		if (!section) {
			event?.preventDefault();
			return;
		}

		// Check if report exists for this section/question
		const hasReport = hasSectionReport(section, isQuestion, data);
		if (!hasReport) {
			event?.preventDefault();
			return;
		}

		if (hasAgreedAiReportDisclaimer) {
			const sectionTab = getSectionTabName(section, isQuestion, data);
			if (sectionTab) {
				setTab(sectionTab);
				// Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
				// Use history.replaceState to ensure the hash persists without triggering navigation
				setTimeout(() => {
					const hashValue = `#${sectionTab}`;
					if (window.location.hash !== hashValue) {
						window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
					}
				}, 100);
			}
			return;
		}

		event.preventDefault();
		const navigationData = { section, isQuestion, data };
		setSectionToNavigate(navigationData);
		sectionToNavigateRef.current = navigationData; // Also store in ref for reliable access
		dispatch(toggleModal({ open: 'DisclaimerAIReportModal' }));
	}, [dispatch, hasAgreedAiReportDisclaimer, setTab, hasSectionReport, getSectionTabName]);

	useEffect(() => {
		if (processing && location.hash && location.hash === "#repository" && showAlert) {
			dispatch(toggleModal({ open: 'repositoryAlert' }))
		}
	}, [processing, location.hash, showAlert])

	let sectionRefs = useRef([]);
	let fileImportRef = useRef(null);

	useEffect(() => {
		const handleScroll = () => {
			const sectionPositions = sectionRefs.current.map(ref => {
				const id = ref?.id?.split('.')[0];
				const top = Math.floor(ref?.getBoundingClientRect().top);
				return { id, top };
			});
			const currentActiveSection = sectionPositions.find(position => position?.['top'] >= 0 && position.top < window.innerHeight);
			if (currentActiveSection) setVisibleSection(currentActiveSection.id);
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const handleEditDispatch = (action) => {
		dispatch(setRModalData({ ...action }))
		dispatch(setOpenRModal(true))
	};

	const syncDrive = async (sectionId, qNo) => {
		if (syncing) return showMessage("Please wait! Syncing is under process")
		dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
		let body = {};
		if (sectionId) body['sectionId'] = sectionId;
		if (qNo) body['qNo'] = qNo;
		body['tab'] = tab;
		body['newUpgradeSync'] = company['syncAfterUpgrade'];
		const res = await postRequest(`/company/syncGDriveDataroom/${companyId}`, body, true);
		if (!res) return;
		if (tab) reloadModule(tab, false, false, true);
		// showMessage(res['message']);
		if (newUpgradeSync) {
			setNewUpgradeSync(false);
		}
		window.location.reload();
		dispatch(setDataroomConfig({ syncing: false, message: null }))
	};

	const syncDropbox = async (sectionId, qNo) => {
		if (syncing) return showMessage("Please wait! Syncing is under process")
		dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
		let body = {};
		if (sectionId) body['sectionId'] = sectionId;
		if (qNo) body['qNo'] = qNo;
		body['tab'] = tab;
		// setNewUpgradeSync(true);
		body['newUpgradeSync'] = company['syncAfterUpgrade'];
		const res = await postRequest(`/company/syncDropBoxDataroom/${companyId}`, body, true);
		if (!res) return;
		if (tab) reloadModule(tab, false, false, true);
		// showMessage(res['message']);
		if (newUpgradeSync) {
			setNewUpgradeSync(false);
			window.location.reload();
		}
		dispatch(setDataroomConfig({ syncing: false, message: null }))
	};

	const reverseSyncDropbox = async (sectionId, qNo) => {
		if (syncing) return showMessage("Please wait! Syncing is under process")
		dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
		let body = {};
		if (sectionId) body['sectionId'] = sectionId;
		if (qNo) body['qNo'] = qNo;
		body['tab'] = tab;
		// setNewUpgradeSync(true);
		body['newUpgradeSync'] = company['syncAfterUpgrade'];
		const res = await postRequest(`/company/reSyncDropBoxDataroom/${companyId}`, body, true);
		if (!res) return;
		if (tab) reloadModule(tab, false, false, true);
		// showMessage(res['message']);
		if (newUpgradeSync) {
			setNewUpgradeSync(false);
			window.location.reload();
		}
		dispatch(setDataroomConfig({ syncing: false, message: null }))
	};

	const syncSharePoint = async (sectionId, qNo) => {
		if (syncing) return showMessage("Please wait! Syncing is under process")
		dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
		let body = {};
		if (sectionId) body['sectionId'] = sectionId;
		if (qNo) body['qNo'] = qNo;
		body['tab'] = tab;
		body['newUpgradeSync'] = company['syncAfterUpgrade'];
		const res = await postRequest(`/company/syncSharePointDataroom/${companyId}`, body, true);
		if (!res) return;
		if (tab) reloadModule(tab, false, false, true);
		// showMessage(res['message']);
		if (newUpgradeSync) {
			setNewUpgradeSync(false);
			window.location.reload();
		}
		dispatch(setDataroomConfig({ syncing: false, message: null }))
	};

	const reSyncSharePoint = async (sectionId, qNo) => {
		if (syncing) return showMessage("Please wait! Syncing is under process")
		dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
		let body = {};
		if (sectionId) body['sectionId'] = sectionId;
		if (qNo) body['qNo'] = qNo;
		body['tab'] = tab;
		body['newUpgradeSync'] = company['syncAfterUpgrade'];
		const res = await postRequest(`/company/reSyncSharePointDataroom/${companyId}`, body, true);
		if (!res) return;
		if (tab) reloadModule(tab, false, false, true);
		// showMessage(res['message']);
		if (newUpgradeSync) {
			setNewUpgradeSync(false);
			window.location.reload();
		}
		dispatch(setDataroomConfig({ syncing: false, message: null }))
	};

	useEffect(() => {
		if (questionsAndAnswersToSave.length) {
			if (isSaving) setSaveTimeout(setTimeout(() => setQuestionsAndAnswersToSave(questionsAndAnswersToSave => [...questionsAndAnswersToSave]), 1000));
			else save()
		}
	}, [questionsAndAnswersToSave, isSaving]);

	const confirmDeleteFile = async (from) => {
		if (deleteFileLoading) return
		setDeleteFileLoading(true)
		let directorId = undefined;
		if (tab.includes('directors-questionnaire')) {
			const dqs = tab.split('_');
			if (dqs.length > 1) directorId = dqs[1];
		}
		let res = {}
		if (tab.includes('directors-questionnaire'))
			res = await postRequest('/repository/deleteFile', { file: deleteFile, questionId: deleteFileQuestionId, companyId, directorId });
		else res = await postRequest('/repository/deleteFile', { file: deleteFile, questionId: deleteFileQuestionId, companyId });
		setDeleteFileLoading(false)
		if (!res || res['code'] != 200) return;

		if (tab) await reloadModule(tab);
		showMessage(res['message']);

		if (section) {
			let _sections = { ...section }
			_sections.files = section.files?.filter(f => f.key != deleteFile.key);
			setSection(_sections);
			setRefresh(!refresh);
		}

		dispatch(toggleModal({ open: from }));
	};

	const confirmDeleteUnallocatedFile = async () => {
		const res = await postRequest('/company/deleteUnallocatedFile', { fileReportId: deleteUnallocatedFile.id, file: deleteUnallocatedFile.file, companyId });
		if (!res || res['code'] != 200) return;

		dispatch(setUnallocatedFiles(unallocatedFiles.filter(f => f.file.key != deleteUnallocatedFile.file.key)));
		showMessage(res['message']);
		dispatch(toggleModal({ open: 'unallocatedFiles' }));
	};

	const onDragOver = e => e.preventDefault();
	const onDrop = (e, question, qNo) => {
		if (!company['uploadedFile'] || !company['syncRequired']) {
			dispatch(setCompany({
				...company,
				uploadedFile: true,
				syncRequired: true
			}));
		}

		e.preventDefault();
		e.target.files = e.dataTransfer.files;
		const fileInput = e.currentTarget.querySelector("input[type='file']");
		if (fileInput) {
			fileInput.value = null; // Reset the input field
		}
		saveAnswer(e, question, qNo);
	};

	const radioButtonChanged = (e, question, qNo, moduleType) => {
		if (company['creatorId']['_id'] != user['_id'] && company['addedByInvestor'] != user['_id'] && (company['servicedBy']['_id'] || company['servicedBy']) != user['_id'] && company['cCategory'] == 'client' && !companyIndex) {
			if (user['role'] == 'Advisor' && !company['advisors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]]) return showMessage('To access this module please contact your account admin');
			if (user['role'] == 'Investor' && !company['investors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]]) return showMessage('To access this module please contact your account admin');
			if ((user['role'] == 'Member' && !company?.['memberPermissions']?.[user['_id']]?.[qNo.split('.')[0]])) return showMessage('To access this module please contact your account admin');
		}

		// question = Object.freeze(question);
		question = JSON.parse(JSON.stringify(question));

		const option = e['target']['dataset']['option'];
		const wrapper = e['target'].closest("[data-question-id]")
		//TODO: change to toggleHeight
		for (const showOrHideEl of wrapper.querySelectorAll(".showOrHide"))
			if (option === "Yes" || option == 'Disclosure') {
				showOrHideEl.classList.remove("dn");
				setTimeout(() => showOrHideEl.classList.remove("op0", "h0"), 100);
			} else {
				showOrHideEl.classList.add("op0", "h0");
				setTimeout(() => showOrHideEl.classList.add("dn"), 300);
			}

		// Send only update keys
		if (!question['answer'] || question['answer'] == undefined) question['answer'] = {};
		else question['answer'] = { _id: question['answer']['_id'], status: question['answer']['status'] };

		question['answer']['radioOption'] = option;
		if (option == 'No') question['answer']['status'] = 'Completed';
		// else if (option == 'N/A') question['answer']['status'] = 'Not Applicable';
		else if (['T', 'Date', 'DropDown'].includes(question['questionType'])) {
			question['answer']['status'] = 'Completed';
			question['answer']['radioOption'] = 'Yes';
		} else if ((question['questionType'].includes('F')) || (option == 'Disclosure' && moduleType == 'warranty-disclosure')) {
			question['answer']['status'] = question['answer']['status'] ?? 'In Progress';
		} else question['answer']['status'] = 'Completed';
		if (!question['updatedBy']) window.scrollTo({ top: window['scrollY'] + 150, behavior: 'smooth' });

		if (["Yes", "No", "N/A"].includes(option) && tab.includes('two-minute-test')) {
			question['answer']['status'] = 'Completed';
		}
		saveAnswer(e, question, qNo, 'radio');
	};

	const cloneFile = (file) => {
		const clonedFile = new File([file], file['name'], { type: file['type'] });
		return clonedFile;
	};

	// handleFileChange — replaced by AutoFill stepper (Filing Assistant now uses autoFillStepper modal)
	// const handleFileChange = async (e) => { ... };

	const sectionNos = ['UD021', 'UD022', 'UD023', 'UD024', 'UD025'];
	const strAdditionalSections = sectionNos.map(sectionNo => {
		const section = company?.["modules"]?.[tab]?.['sections'].find((sec) => sec?.sectionNo === sectionNo)
		if (section && section.type === "Additional Sections" && section['companyId'] && section['sectionName'] !== "") {
			return [sectionNo, section.sectionName, true, true];
		} else {
			return [sectionNo, "", false, true];
		}
	});

	let [additionalSections, setAdditionalSections] = useState(strAdditionalSections);
	const [isSectionNameDuplicate, setIsSectionNameDuplicate] = useState({ indexes: [], name: '' })

	const findDuplicates = (arr) => {
		const map = arr.reduce((acc, [index, name]) => {
			if (name !== "") (acc[name.toLowerCase().trim()] = acc[name.toLowerCase().trim()] || []).push(index);
			return acc;
		}, {});

		for (const [name, indexes] of Object.entries(map)) {
			if (indexes.length > 1) return { indexes, name };
		}

		return { indexes: [], name: '' };
	};

	function editSectionName(strVal, index) {
		let newArray = [...additionalSections];
		newArray[index][1] = strVal;
		setAdditionalSections(newArray);
		const newSetData = findDuplicates(newArray)
		newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({ indexes: [], name: '' })
	};

	function onEdit(index) {
		let newArray = [...additionalSections];
		if (newArray[index][3] === true && newArray[index][1] === "") return showMessage('Please input additional user-defined sections name!');
		newArray[index][3] = !newArray[index][3];
		setAdditionalSections(newArray);
		const newSetData = findDuplicates(newArray)
		newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({ indexes: [], name: '' })
	};

	async function onDelete(index) {
		const selectedSection = company["modules"][tab]['sections'].find((sec) => sec.sectionNo === additionalSections[index][0])
		let connectDataroomConfig = 0;
		if (company['gDriveLink']) connectDataroomConfig = 1;
		if (company['dropBoxLink']) connectDataroomConfig = 2;
		if (company['sharePointLink']) connectDataroomConfig = 3;
		try {
			const resp = await postRequest('/repository/delete/customSections', {
				sectionId: selectedSection._id,
				companyId,
				connectDataroomConfig
			})
			if (resp['code'] === 200) {
				let newArray = [...additionalSections];
				newArray[index][2] = false;
				newArray[index][3] = true;
				newArray[index][1] = "";
				setAdditionalSections(newArray);
				const newSetData = findDuplicates(newArray)
				const restIndexes = newSetData.indexes.length ? newSetData.indexes.filter((item) => item !== newArray[index][0]) : []
				newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({ indexes: restIndexes, name: '' })
				showMessage(resp['message']);
				dispatch(toggleModal({ open: '' }));
				if (tab) reloadModule(tab, true, true);
			}
		} catch (err) { console.log(err) }

	};

	const onSaveAdditionalSections = async () => {
		if (isSectionNameDuplicate.indexes.length && isSectionNameDuplicate.name !== '') return
		let sectionNames = additionalSections.map(section => section[1])
		if (sectionNames.every(val => val === '')) {
			return showMessage("Please enter minimum one section name.");
		}

		let connectDataroomConfig = 0;
		if (company['gDriveLink']) connectDataroomConfig = 1;
		if (company['dropBoxLink']) connectDataroomConfig = 2;
		if (company['sharePointLink']) connectDataroomConfig = 3;
		const additionalQuestion = "Please upload any file related to this section"

		const res = await postRequest(`/repository/addSection/`, { type: 'Additional Sections', sectionNos, sectionNames, companyId, tab, connectDataroomConfig, qDescription: additionalQuestion });

		showMessage(res['message']);
		dispatch(toggleModal({ open: '' }));
		if (tab) reloadModule(tab, false, true);
	};

	const saveAnswer = (e, question, sectionNo, type) => {
		if (permissionLevel == 'DASHBOARD') {
			showMessage('To access this module please contact your account admin');
			return;
		}

		let subAnswers;
		if (question['qNo'] == 'DEPF008.3.1' && question?.['answer']?.['subAnswers']) subAnswers = question['answer']['subAnswers']

		question = JSON.parse(JSON.stringify(question));
		// Send only update keys
		const originalStatus = question['answer']?.['status'];
		if (type != 'radio' && question['answer']) question['answer'] = { _id: question['answer']['_id'] };

		if (['T', 'F/T', 'Date', 'DropDown', 'Radio', 'Multi'].includes(question['questionType'])) {
			question['answer'].status = 'Completed';
			question['answer'].radioOption = 'Yes';
		}

		if (['YN/F/T'].includes(question['questionType']) && question['answer'].radioOption == 'N/A') {
			question['answer'].status = 'Completed';
		}

		clearTimeout(saveTimeout);
		let questionAndAnswerToSave = questionsAndAnswersToSave.find(q => q._id == question['_id']);
		if (!questionAndAnswerToSave) {
			questionAndAnswerToSave = {
				...question,
				sectionNo,
				moduleType: question['type'],
				answer: {
					_id: question.answer?._id,
					fileIndexes: [],
					logs: question.answer?.logs,
					...question.answer
				}
			};
			if (question?.['answer']?.['status']) questionAndAnswerToSave['answer']['status'] = question['answer']['status'];
			questionsAndAnswersToSave.push(questionAndAnswerToSave);
		}

		if (question['qNo'] == 'DEPF008.3.1') {
			if (!questionAndAnswerToSave['answer']['subAnswers']) questionAndAnswerToSave['answer']['subAnswers'] = {};
			if (subAnswers) questionAndAnswerToSave['answer']['subAnswers'] = { ...subAnswers, [e.target.name]: e.target.value };
			else questionAndAnswerToSave['answer']['subAnswers'][e.target.name] = e.target.value;
		}
		else if (question['questionType'] == 'Radio') questionAndAnswerToSave.answer['dropdown'] = e.target.dataset.option;
		else if (question['questionType'] == 'Multi') {
			let answer = '';
			e.target.value.map(value => {
				if (value.length == 0) return;
				if (answer.length > 0) answer = answer + ';' + value;
				else answer = value;
			})
			questionAndAnswerToSave.answer[e.target.name] = answer;
		}
		else if (e.target.dataset && e.target.dataset.option) {
			questionAndAnswerToSave.answer.radioOption = e.target.dataset.option;
		}
		else if (e.target.files) {
			for (const file of e.target.files) {
				let index = attachment.push(file) - 1;
				questionAndAnswerToSave.answer.fileIndexes.push(index);
			}
			//showMessage("Uploading files");
			if (!company['uploadedFile'] || !company['syncRequired']) {
				dispatch(setCompany({
					...company,
					uploadedFile: true,
					syncRequired: true
				}));
			}
			if (question['questionType'] == 'D/ND') questionAndAnswerToSave.answer.radioOption = 'Disclosure';
			else {
				questionAndAnswerToSave.answer.radioOption = 'Yes';
			}
		}
		else if (e.target.type === "checkbox") {
			questionAndAnswerToSave.answer.status = e.target.checked ? "Completed" : "In Progress";
			if (!question['answer']['_id']) {
				questionAndAnswerToSave.answer.radioOption = question['questionType'] == 'D/ND' ? 'Disclosure' : 'Yes';
			}
		} else {
			questionAndAnswerToSave.answer[e.target.name] = e.target.value || e.target.checked;
			if (e.target.name === 'isReviewed' && originalStatus) questionAndAnswerToSave.answer.status = originalStatus;
		}
		if (e.target.files) setQuestionsAndAnswersToSave(questionsAndAnswersToSave => [...questionsAndAnswersToSave]);
		else setSaveTimeout(setTimeout(() => setQuestionsAndAnswersToSave(questionsAndAnswersToSave => [...questionsAndAnswersToSave]), 10));
	};

	const save = async () => {
		setIsSaving(true);
		setQuestionsAndAnswersToSave([]);
		let companyClone = JSON.parse(JSON.stringify({ ...company }));
		let currentCount = 0, percent = 0, filesInfo = [];
		const totalFileCount = attachment.length;
		for (const file of attachment) {
			const res = await postRequest(`/question/newUploadFile`, { attachment: [file] }, true);
			if (!res) continue;
			if (!res.body?.['result']) continue;
			currentCount++;
			filesInfo.push(res.body['result']);
			percent = Math.round((currentCount / totalFileCount) * 100);
			dispatch(toggleModal({ open: 'computerToDataRepository', percent, fileName: file['name'], totalFiles: totalFileCount, filesUploaded: currentCount }));
		}

		if (localStorage.getItem('companyId')) companyId = localStorage.getItem('companyId');

		const res = await postRequest('/question/newSaveAnswers', { files: filesInfo, companyId, questionsAndAnswersToSave });
		dispatch(toggleModal({ open: '' }));
		if (!res || res['code'] != 200) return setIsSaving(false);
		const { answerErrors, savedQuestions } = res['body'];
		for (let question of savedQuestions) {
			let { sectionNo, _id } = question;
			let moduleName = question['moduleType'] || question['type'];
			if (window.location.hash.includes('directors-questionnaire')) moduleName = window.location.hash.replace('#', '');
			let module = companyClone['modules'][moduleName];
			if (answerErrors[_id]) {
				showMessage(answerErrors[_id]);
				continue;
			}

			// This is for expension pack subsections
			if (module?.['expansionPack'])
				for (let key of Object.keys(module.sections[0]['subFolders'])) {
					let section = module.sections[0]['subFolders'][key];
					if (sectionNo.includes(section['sectionNo'])) {
						section['updatedAt'] = Date.now();
						let questionIndex = section['questions'].findIndex(({ _id }) => _id == question['_id']);
						module.sections[0]['subFolders'][key]['questions'][questionIndex] = question;
					}
				}
			// This question update is for other modules than expansion packs
			else {
				if (module?.sections) for (let section of module?.sections) {
					if (sectionNo.includes(`${section['sectionNo']}`)) {
						section['updatedAt'] = Date.now();
						if (section?.['subFolders']) {
							for (let key of Object.keys(section['subFolders'])) section['subFolders'][key]['updatedAt'] = Date.now();
						}
						if (section?.['subFolders']?.['subFolders']) {
							for (let key of Object.keys(section['subFolders']['subFolders'])) section['subFolders']['subFolders'][key]['updatedAt'] = Date.now();
						}
						let questionIndex = section['questions'].findIndex(({ _id }) => _id == question['_id']);
						// question['answer']['logs'] = section['questions'][questionIndex]?.['answer']?.['logs']; // Keep previous logs with user details
						section['updatedAt'] = Date.now();
						section['questions'][questionIndex] = question;
						if (question['answer']['updatedBy']) section['questions'][questionIndex]['answer']['updatedBy'] = question['answer']['updatedBy'];
					}
				}
			}

			companyClone.modules[moduleName] = module;
		}
		dispatch(setCompany(calculateStats(companyClone, tab, "check2")));
		//if (!repoStarted) setRepoStarted(!!repositoryClone.answers?.find(a => a.radioOption));
		setAttachment([]); //TODO: only remove successful attachments. undo answers set on UI like radio button checks and files selected if it failed
		//questionsAndAnswersToSave.push(...currentQuestionsAndAnswersToSave); //TODO: add failed ones back
		setIsSaving(false);
		showMessage(res['message']);
		return spinner.classList.add("op0")
	};

	const onClickDeduperAuditLog = async () => {
		const res = await getRequest(`/company/getDeduperReportLog/${companyId}`);
		dispatch(setLogList(res['body']))
		dispatch(toggleModal({ open: 'deduperReportAuditLog' }))
	};

	const onClickUnallocatedBinAuditLog = async () => {
		const res = await getRequest(`/company/getUnallocatedBinLog/${companyId}`);
		dispatch(setLogList(res['body']))
		dispatch(toggleModal({ open: 'unallocatedBinAuditLog' }))
	};

	const moveUnallocatedFile = async ({ payload }) => {
		if (payload.length) {
			const res = await postRequest('/company/moveUnallocateFiles', {
				payload,
				companyId,
				tab
			});
			if (!res || res['code'] != 200) return;

			await reloadModule("repository", true);
			showMessage(res['message']);
			const filteredUnallocatedFiles = unallocatedFiles.filter(uf => !uf?.sectionNo);
			dispatch(setUnallocatedFiles(filteredUnallocatedFiles));
			setRefresh(!refresh);
			dispatch(toggleModal({ open: "" }))
		} else {
			showMessage('Please select target section');
		}
	};

	const moveDeduperFile = async ({ payload }) => {
		if (payload.length) {
			const res = await postRequest('/company/moveDeduperFile', {
				companyId,
				tab,
				actions: payload
			});
			if (!res || res['code'] != 200) return;
			const newReport = res['body'];

			if (tab) await reloadModule(tab, true);
			showMessage(res['message']);

			dispatch(setDeduperFiles(JSON.parse(JSON.stringify(newReport))))
			// setDupCheck();
			let curSection = {};
			for (const dupFiles of Object.values(newReport.deduperResult || {})) {
				if (!Array.isArray(dupFiles)) continue;
				for (const dupFile of dupFiles) {
					if (dupFile?.file?.key) {
						curSection[dupFile.file.key] = {
							qNo: dupFile.qNo,
							name: dupFile.name
						};
					}
				}
			}

			dispatch(setTargetSection(curSection));
			setRefresh(!refresh);
		} else {
			showMessage('Please select target section');
		}
	};

	const onClickFileReportHistory = async () => {
		setFAMenuVisible(false);
		const res = await getRequest(`/company/getFileReportHistory/${companyId}`);
		setReportHistories(res['body']);
		dispatch(toggleModal({ open: 'fileReportHistory' }))
	};

	const showDeduperReport = (report) => {
		// setDupCheck(JSON.parse(JSON.stringify(report)));
		// setDupCheck(report);
		dispatch(setDeduperFiles(report))
		let curSection = {};
		if (report?.deduperResult && typeof report.deduperResult === "object") {
			for (const dupFiles of Object.values(report.deduperResult)) {
				if (!Array.isArray(dupFiles)) continue;

				for (const dupFile of dupFiles) {
					if (dupFile?.file?.key) {
						curSection[dupFile.file.key] = {
							qNo: dupFile.qNo,
							name: dupFile.name
						};
					}
				}
			}
		}
		dispatch(setTargetSection(curSection));
		dispatch(toggleModal({ open: 'duplicationCheckSummary' }));
	};

	const onClickDeduperReportHistory = async () => {
		setFAMenuVisible(false);
		const res = await getRequest(`/company/getDeduperReportHistory/${company['_id']}`);
		if (res && res.body && !res['body'].length) {
			return checkDuplicatedFiles()
		}
		if (res['body'] && Array.isArray(res['body']) && res['body'].length > 0) {
			showDeduperReport(res['body'][0]);
		} else {
			showDeduperReport({});
		}
		// setDeduperHistories(res['body']);
		// dispatch(toggleModal({ open: 'deduperReportHistory' }))
	};

	const handleToggleSuccessAiReportGeneratedModal = async (redirect) => {
		// Close the success modal first
		dispatch(toggleModal({ open: '' }));

		// If user wants to view the report, show disclaimer
		// Navigation will be handled in handleAiReportDisclaimerClose after user clicks "Understood"
		if (redirect) {
			dispatch(toggleModal({ open: 'DisclaimerAIReportModal' }));
		}
	};

	const generateInsuranceAiReport = async ({ data, isQuestion }) => {
		setFAMenuVisible(false);
		const allFiles = isQuestion ? [...(data.answer.files.map(file => file.location) || [])] : (data?.questions || data?.section?.questions).flatMap(q => q.answer.files.map(file => file.location) || []).filter(Boolean);
		const generatingKey = getReportGenerationKey(data, isQuestion);
		const requestId = startReportGenerationLoading(generatingKey);

		if (!companyObjectId) {
			showMessage('Unable to generate analysis report. Missing company identifier.');
			stopReportGenerationLoading(requestId);
			return;
		}

		showMessage(`The report generation process is in progress and may take approximately 8 to 10 minutes to complete.`)

		try {
			const sectionId = isQuestion ? data.sectionId : (data?.['_id'] || data.section._id);

			const res = await postRequest(`/company/generateSectionReport/${companyObjectId}/${sectionId}`, {
				"companyId": companyObjectId,
				"files": allFiles,
				"query": 'You are a legal diligence report writer. Follow instructions strictly.',
				"isQuestion": isQuestion,
				...(isQuestion ? { data } : {})
			});


			// if (true) {
			if (res?.['code'] == 200) {
				showMessage(res['message']);

				const reportType = res?.body?.reportType || null;
				expectedReportTypeRef.current = reportType
				let sectionData = null;
				if (isQuestion && data?.sectionId) {
					// Try to find the section from company data using sectionId
					if (company?.modules) {
						for (const module of Object.values(company.modules)) {
							if (module?.sections) {
								sectionData = Object.values(module.sections).find(
									sec => sec._id === data.sectionId || sec._id?.toString() === data.sectionId?.toString()
								);
								if (sectionData) break;
							}
						}
					}
				} else if (!isQuestion) {
					// For section reports, data is the section itself
					sectionData = data;
				}

				// Store navigation data (section may be null for questions, but we have qNo in data)
				const anchor = (sectionData?.sectionNo || sectionData?.no || data?.sectionNo || data?.qNo || null);
				if (anchor) {
					lastReportAnchorRef.current = anchor;
					try {
						localStorage.setItem('lastReportAnchor', anchor);
					} catch (_) { /* ignore */ }
				}
				setSectionToNavigate({ section: sectionData, isQuestion, data });
				sectionToNavigateRef.current = { section: sectionData, isQuestion, data };

				dispatch(toggleModal({ open: 'successAiReportGenerated' }))
			} else {
				showMessage(res?.['message'] || 'Unable to generate analysis report');
			}
		} catch (error) {
			showMessage(error?.message || 'Unable to generate analysis report');
		} finally {
			stopReportGenerationLoading(requestId, { force: true });
			setTimeout(() => {
				if (isComponentMountedRef.current) {
					const loadingMap = getPersistedReportLoadingMap();
					const entry = loadingMap[companyObjectId];
					if (!entry || entry.status !== 'pending') {
						setReportGenerateLoadingState(null);
						reportGenerationRequestRef.current = null;
					}
				}
			}, 200);
		}
	};

	const onClickViewUnallocatedFiles = async () => {
		setFAMenuVisible(false);
		const res = await getRequest(`/company/unallocatedFiles/${companyId}`);
		dispatch(setTargetSection({}));
		dispatch(setUnallocatedFiles(res['body']['unallocated']));
		dispatch(toggleModal({ open: 'unallocatedFiles' }));
	};

	const checkDuplicatedFiles = async () => {
		setFAMenuVisible(false);
		dispatch(toggleModal({ open: 'checkingDuplication' }));
		const res = await postRequest(`/company/checkDuplicate`, { companyId, tab });
		if (res?.code === 200 && res['body']) showDeduperReport(res['body']);
		else dispatch(toggleModal({ open: '' }));
	};

	const getViewableURL = (url) => {
		window.open(url, "_blank");
	};

	const getDeduperReportLogsHTML = (logs) => logs.map((log, idx) => {
		if (!log['files']) return <> </>
		else return (
			<div key={`deduper-log-${idx}-${log.timestamp}`} className="df my0-5rem">
				{log?.['userId']?.['profile']
					&& <img className={`ass mr0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
					|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
				}
				<div className="w100">
					<span className='fs0-75rem c15'><b>{log['message']} by {log?.['userId']?.['firstName']} </b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>

					{log['files'].length > 0 && <>
						<p className="df fs0-75rem mb0-5rem">Files: {log['files'].map((file, fileIdx) => <div key={`deduper-log-file-${idx}-${fileIdx}-${file['originalname']}`} onClick={() => getViewableURL(file['location'])} className="db c3-hover fw600 tdu fs0-75rem ml0-5rem cp">{file['originalname']}</div>)}</p>
					</>
					}

					{log?.['change'] &&
						<div className="shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem">
							<p><b>Comment</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p>
						</div>
					}
				</div>
			</div>
		)
	});

	const getFileReportLogsHTML = (logs) => logs.map((log, idx) => {
		if (!log['files']) return <> </>
		else return (
			<div key={`file-report-log-${idx}-${log.timestamp}`} className="df my0-5rem">
				{log?.['userId']?.['profile']
					&& <img className={`ass mr0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
					|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
				}
				<div className="w100">
					<span className='fs0-75rem c15'><b>{log['message']} by {log?.['userId']?.['firstName']} </b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>

					{log['files'].length > 0 && <>
						<p className="df fs0-75rem mb0-5rem">Files: {log['files'].map((file, fileIdx) => <div key={`file-report-log-file-${idx}-${fileIdx}-${file['originalname']}`} onClick={() => getViewableURL(file['location'])} className="db c3-hover fw600 tdu fs0-75rem ml0-5rem cp">{file['originalname']}</div>)}</p>
					</>
					}
					{log?.['change'] &&
						<div className="shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem">
							<p className=""><b>Changed Status</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p>
							<p><b>Assistant Accuracy</b>: {log?.['change']?.accuracy != undefined ? log?.['change']?.accuracy : '-'}%</p>
							{/* <p><b>Updated Comment</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p> */}
						</div>
					}
				</div>
			</div>
		)
	});

	const getUnallocatedBinLogsHTML = (logs) => logs.map((log, idx) => {
		if (!log['files']) return <> </>
		else return (
			<div key={`unallocated-bin-log-${idx}-${log.timestamp}`} className="df my0-5rem">
				{log?.['userId']?.['profile']
					&& <img className={`ass mr0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
					|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
				}
				<div className="w100">
					<span className='fs0-75rem c15'><b>{log['message']} by {log?.['userId']?.['firstName']} </b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>

					{log['files'].length > 0 && <>
						<p className="df fs0-75rem mb0-5rem">Files: {log['files'].map((file, fileIdx) => <div key={`unallocated-bin-log-file-${idx}-${fileIdx}-${file['originalname']}`} onClick={() => getViewableURL(file['location'])} target="_blank" className="db c3-hover fw600 tdu fs0-75rem ml0-5rem cp">{file['originalname']}</div>)}</p>
					</>
					}
					{/* {log?.['change'] &&
						<div className="shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem">
							<p className=""><b>Changed Status</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p>
						</div>
					} */}
				</div>
			</div>
		)
	});

	const onClickFileManager = (section, questionIndex) => {
		let curSection = { ...targetSection };
		if (section && section.files && section.files.length > 0) {
			section.files.map(file => {
				curSection[file.key] = { qNo: section.sectionNo || section.no, name: section.sectionName || section.name };
			})
		}
		dispatch(setTargetSection(curSection));
	};

	const answerSaved = (answer) => {
		let updatedBy = answer?.['updatedBy']?.[0] || answer?.['updatedBy'];

		if (updatedBy?.['firstName']) {
			let answerClass = (updatedBy?.['role'] == 'Advisor' ? 'advisor-profile' : updatedBy?.['role'] == 'Investor' ? 'investor-profile' : 'client-profile');
			return (
				<div className="df my0-5rem">
					{updatedBy?.['profile'] && <img className={`ass mr0-5rem br100 w2rem h2rem ${answerClass}`} src={updatedBy['profile']} data-tooltip={updatedBy['firstName'] ? (updatedBy['firstName'] + " " + updatedBy['lastName']) : "Register to show your name here"} />
						|| <span className={`shadow ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem c15 bg16 ${answerClass}`} data-tooltip={updatedBy?.['firstName'] ? (updatedBy['firstName'] + " " + updatedBy['lastName']) : "Register to show your name here"}>{updatedBy?.['firstName']?.[0] || "?"}{updatedBy?.['lastName']?.[0] || "?"}</span>}
					<div className="w100">
						<span className='fs0-75rem c15'><b>Answer Saved</b>, <b>{moment(answer['updatedAt']).format('lll')}</b></span>
					</div>
				</div>
			)
		}
	};

	const handleSectionLogs = async (id) => {
		const res = await getRequest(`/question/getLogs/${id}`);
		dispatch(setLogList(res['body']))
		dispatch(toggleModal({ open: 'auditLog' }))
	};

	const openWindow = (url) => {
		if (window.innerWidth <= 640) {
			var a = document.createElement('a');
			a.setAttribute("href", url);
			a.setAttribute("target", "_blank");

			var dispatch = document.createEvent("HTMLEvents");
			dispatch.initEvent("click", true, true);

			a.dispatchEvent(dispatch);
		}
		else {
			var width = window.innerWidth * 0.8;
			var height = width * window.innerHeight / window.innerWidth;
			window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + ((window.innerHeight - height) / 2) + ', left=' + ((window.innerWidth - width) / 2));
		}
		return false;
	};

	const getFilesFromQuestions = questions => questions && questions.filter(q => q.answer?.files?.length)
		.reduce((arr, q) => [...arr, ...q.answer.files.map(file => ({
			...file,
			questionId: q._id,
			title: file.originalname,
			url: file.location,
			ext: file.originalname.split(".").slice(-1)[0],
		}))], []);

	const showRiskRecommendation = (key) => {
		return <h5 className="fs1rem fsi mt2rem df aic c15">
			{key.includes("recommend")
				? <><svg className="mr0-5rem" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21.0954 10.0946C21.0954 5.89534 17.6873 2.49208 13.4862 2.50001C9.32805 2.50787 5.97026 5.81889 5.90715 9.97656C5.86673 12.6385 7.19613 14.9926 9.23603 16.3795C9.24414 16.385 9.24902 16.3941 9.24902 16.404C9.6515 16.6551 9.8961 17.0961 9.8961 17.5705V19.2815H17.1055V17.555C17.1055 17.0891 17.3416 16.6547 17.7326 16.4013L17.7526 16.3883C19.7696 15.023 21.0954 12.7136 21.0954 10.0946Z" fill="url(#paint0_linear_5984_51730)" />
					<path d="M13.5034 15.3135C16.3444 15.3135 18.6474 13.0104 18.6474 10.1694C18.6474 7.32845 16.3444 5.02539 13.5034 5.02539C10.6624 5.02539 8.35938 7.32845 8.35938 10.1694C8.35938 13.0104 10.6624 15.3135 13.5034 15.3135Z" fill="url(#paint1_linear_5984_51730)" />
					<path d="M20.6955 12.5354L15.9165 7.7564C15.8453 7.62505 15.7329 7.5332 15.5718 7.5332H11.5191C11.2095 7.5332 11.0781 7.87094 11.0781 8.1805C11.0781 8.46824 11.1821 8.72517 11.3702 8.81365L12.8136 10.2856V13.9406C12.8136 14.0885 12.9026 14.1997 13.0365 14.2748L17.107 18.3453V17.5559C17.107 17.0899 17.343 16.6556 17.7341 16.4021L17.7541 16.3891C19.1136 15.4689 20.1584 14.1193 20.6955 12.5354Z" fill="url(#paint2_linear_5984_51730)" />
					<path d="M15.5249 7.49023H11.4722C11.1626 7.49023 11.0312 7.82797 11.0312 8.13753C11.0312 8.49403 11.1907 8.80359 11.4722 8.80359H12.7668V13.8976C12.7668 14.1978 13.1327 14.3479 13.4986 14.3479C13.8645 14.3479 14.2303 14.1978 14.2303 13.8976V8.80359H15.525C15.8064 8.80359 15.9659 8.49403 15.9659 8.13753C15.9658 7.82792 15.8344 7.49023 15.5249 7.49023Z" fill="url(#paint3_linear_5984_51730)" />
					<path d="M23.8094 9.42578H22.1956C21.8115 9.42578 21.5 9.7372 21.5 10.1214C21.5 10.5055 21.8114 10.817 22.1956 10.817H23.8094C24.1935 10.817 24.505 10.5056 24.505 10.1214C24.505 9.7372 24.1936 9.42578 23.8094 9.42578Z" fill="url(#paint4_linear_5984_51730)" />
					<path d="M5.505 10.1214C5.505 9.73724 5.19358 9.42578 4.80939 9.42578H3.19561C2.81142 9.42578 2.5 9.7372 2.5 10.1214C2.5 10.5055 2.81142 10.817 3.19561 10.817H4.80939C5.19354 10.817 5.505 10.5055 5.505 10.1214Z" fill="url(#paint5_linear_5984_51730)" />
					<path d="M21.7422 13.985C21.4705 13.7133 21.0301 13.7133 20.7584 13.985C20.4868 14.2566 20.4868 14.6971 20.7584 14.9687L21.8995 16.1098C22.1712 16.3815 22.6116 16.3815 22.8833 16.1098C23.1549 15.8382 23.1549 15.3977 22.8833 15.1261L21.7422 13.985Z" fill="url(#paint6_linear_5984_51730)" />
					<path d="M5.10153 4.13342C4.82989 3.86178 4.38944 3.86178 4.1178 4.13342C3.84615 4.40507 3.84615 4.84551 4.1178 5.11716L5.2589 6.25826C5.53055 6.52991 5.97099 6.52991 6.24264 6.25826C6.51428 5.98662 6.51428 5.54617 6.24264 5.27453L5.10153 4.13342Z" fill="url(#paint7_linear_5984_51730)" />
					<path d="M6.24264 13.985C5.97099 13.7133 5.53055 13.7133 5.2589 13.985L4.1178 15.1261C3.84615 15.3977 3.84615 15.8382 4.1178 16.1098C4.38944 16.3815 4.82989 16.3815 5.10153 16.1098L6.24264 14.9687C6.51428 14.697 6.51428 14.2566 6.24264 13.985Z" fill="url(#paint8_linear_5984_51730)" />
					<path d="M20.7584 6.25826C21.0301 6.52991 21.4705 6.52991 21.7422 6.25826L22.8833 5.11716C23.1549 4.84551 23.1549 4.40507 22.8833 4.13342C22.6116 3.86178 22.1712 3.86178 21.8995 4.13342L20.7584 5.27453C20.4868 5.54617 20.4868 5.98662 20.7584 6.25826Z" fill="url(#paint9_linear_5984_51730)" />
					<path d="M17.1077 17.9497L14.4774 15.3194C14.2488 15.0502 13.908 14.8789 13.5271 14.8789C12.839 14.8789 12.2812 15.4367 12.2812 16.1248C12.2812 16.1696 12.2834 16.2141 12.2882 16.2576C12.3227 16.5842 12.484 16.8732 12.7217 17.0751L14.9278 19.2812H17.1077V17.9497Z" fill="url(#paint10_linear_5984_51730)" />
					<path d="M13.4959 17.3454C14.184 17.3454 14.7419 16.7876 14.7419 16.0994C14.7419 15.4113 14.184 14.8535 13.4959 14.8535C12.8078 14.8535 12.25 15.4113 12.25 16.0994C12.25 16.7876 12.8078 17.3454 13.4959 17.3454Z" fill="url(#paint11_linear_5984_51730)" />
					<path d="M6.42188 12.8516C6.98406 14.2927 7.97314 15.5202 9.23444 16.3778C9.24255 16.3833 9.24742 16.3924 9.24742 16.4022C9.6499 16.6534 9.8945 17.0943 9.8945 17.5687V19.2797H17.1039V17.5533C17.1039 17.0873 17.3399 16.653 17.731 16.3995L17.751 16.3865C19.0185 15.5286 20.0127 14.2977 20.5768 12.8516H6.42188V12.8516Z" fill="url(#paint12_linear_5984_51730)" />
					<path d="M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z" fill="url(#paint13_linear_5984_51730)" />
					<path d="M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z" fill="url(#paint14_linear_5984_51730)" />
					<path d="M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z" fill="url(#paint15_linear_5984_51730)" />
					<path d="M16.6766 20.4238H10.3136C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3417 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3417 20.4238 16.6766 20.4238Z" fill="url(#paint16_linear_5984_51730)" />
					<path d="M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z" fill="url(#paint17_linear_5984_51730)" />
					<path d="M16.6766 20.4238L13.5082 20.3066L10.3136 20.4238C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3418 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3418 20.4238 16.6766 20.4238Z" fill="url(#paint18_linear_5984_51730)" />
					<defs>
						<linearGradient id="paint0_linear_5984_51730" x1="7.93971" y1="5.55907" x2="17.0821" y2="14.7015" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint1_linear_5984_51730" x1="11.5881" y1="8.25411" x2="19.3877" y2="16.0536" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint2_linear_5984_51730" x1="19.8051" y1="16.3438" x2="7.67629" y2="4.21497" gradientUnits="userSpaceOnUse">
							<stop stop-color="#D52C1C" stop-opacity="0" />
							<stop offset="0.28" stop-color="#D12C1E" stop-opacity="0.28" />
							<stop offset="0.5735" stop-color="#C42C23" stop-opacity="0.574" />
							<stop offset="0.8721" stop-color="#AF2B2C" stop-opacity="0.872" />
							<stop offset="1" stop-color="#A42B31" />
						</linearGradient>
						<linearGradient id="paint3_linear_5984_51730" x1="11.5522" y1="8.09465" x2="16.2824" y2="12.8249" gradientUnits="userSpaceOnUse">
							<stop stop-color="#E38523" />
							<stop offset="1" stop-color="#C4237C" />
						</linearGradient>
						<linearGradient id="paint4_linear_5984_51730" x1="20.5813" y1="9.21341" x2="25.2617" y2="10.9686" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint5_linear_5984_51730" x1="1.58127" y1="9.21341" x2="6.26166" y2="10.9686" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint6_linear_5984_51730" x1="19.4346" y1="14.1526" x2="24.0474" y2="15.8824" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint7_linear_5984_51730" x1="2.794" y1="4.30097" x2="7.40674" y2="6.03075" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint8_linear_5984_51730" x1="3.46243" y1="14.4032" x2="6.78304" y2="15.6485" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint9_linear_5984_51730" x1="20.1031" y1="4.55165" x2="23.4237" y2="5.79689" gradientUnits="userSpaceOnUse">
							<stop stop-color="#F7E07D" />
							<stop offset="1" stop-color="#E69642" />
						</linearGradient>
						<linearGradient id="paint10_linear_5984_51730" x1="17.1961" y1="19.7937" x2="13.3824" y2="15.98" gradientUnits="userSpaceOnUse">
							<stop stop-color="#D52C1C" stop-opacity="0" />
							<stop offset="0.28" stop-color="#D12C1E" stop-opacity="0.28" />
							<stop offset="0.5735" stop-color="#C42C23" stop-opacity="0.574" />
							<stop offset="0.8721" stop-color="#AF2B2C" stop-opacity="0.872" />
							<stop offset="1" stop-color="#A42B31" />
						</linearGradient>
						<linearGradient id="paint11_linear_5984_51730" x1="12.8755" y1="15.4789" x2="14.0165" y2="16.62" gradientUnits="userSpaceOnUse">
							<stop stop-color="#E38523" />
							<stop offset="1" stop-color="#C4237C" />
						</linearGradient>
						<linearGradient id="paint12_linear_5984_51730" x1="13.4994" y1="14.7928" x2="13.4994" y2="18.3093" gradientUnits="userSpaceOnUse">
							<stop stop-color="#D52C1C" stop-opacity="0" />
							<stop offset="0.28" stop-color="#D12C1E" stop-opacity="0.28" />
							<stop offset="0.5735" stop-color="#C42C23" stop-opacity="0.574" />
							<stop offset="0.8721" stop-color="#AF2B2C" stop-opacity="0.872" />
							<stop offset="1" stop-color="#A42B31" />
						</linearGradient>
						<linearGradient id="paint13_linear_5984_51730" x1="13.4951" y1="18.721" x2="13.4951" y2="20.1877" gradientUnits="userSpaceOnUse">
							<stop stop-color="#EEF4FF" />
							<stop offset="1" stop-color="#CFE7FD" />
						</linearGradient>
						<linearGradient id="paint14_linear_5984_51730" x1="10.5019" y1="23.2286" x2="15.9964" y2="23.2286" gradientUnits="userSpaceOnUse">
							<stop stop-color="#5A5A5A" />
							<stop offset="1" stop-color="#464646" />
						</linearGradient>
						<linearGradient id="paint15_linear_5984_51730" x1="13.4996" y1="24.1335" x2="13.4996" y2="23.2058" gradientUnits="userSpaceOnUse">
							<stop stop-color="#464646" stop-opacity="0" />
							<stop offset="1" stop-color="#202020" />
						</linearGradient>
						<linearGradient id="paint16_linear_5984_51730" x1="13.4951" y1="20.7913" x2="13.4951" y2="22.519" gradientUnits="userSpaceOnUse">
							<stop stop-color="#EEF4FF" />
							<stop offset="1" stop-color="#CFE7FD" />
						</linearGradient>
						<linearGradient id="paint17_linear_5984_51730" x1="13.4951" y1="19.2818" x2="13.4951" y2="20.7916" gradientUnits="userSpaceOnUse">
							<stop stop-color="#8AAADC" stop-opacity="0" />
							<stop offset="1" stop-color="#8AAADC" />
						</linearGradient>
						<linearGradient id="paint18_linear_5984_51730" x1="13.4952" y1="21.7098" x2="13.4952" y2="22.7287" gradientUnits="userSpaceOnUse">
							<stop stop-color="#8AAADC" stop-opacity="0" />
							<stop offset="1" stop-color="#8AAADC" />
						</linearGradient>
					</defs>
				</svg>
					Recommendation:</>
				: <><svg className="f4 mr0-5rem mah2rem maw2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path className="fa-primary" d="M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z" /><path className="fa-secondary" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z" /></svg>
					Risk:</>
			}
		</h5>
	};

	const sortQuestionsByQNo = (questions) => {
		if (questions.length > 0) {
			return questions.sort((a, b) => {
				const aParts = a['qNo'].match(/\d+/g).map(Number);
				const bParts = b['qNo'].match(/\d+/g).map(Number);
				for (let i = 0; i < Math.max(aParts.length, bParts.length); i++)
					if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
				return 0;
			});
		}
	};

	const onAccurateFileName = () => {
		dispatch(updateFileAllocation({ autoFillContext: { enabled: false, companyId, moduleType: tab, sectionCode: null, scope: 'module', scopeName: '' }, tab }));
		dispatch(toggleModal({ open: 'autoFillStepper', autoFillStepperPhase: 'select', autoFillStatusBarPhase: 'select', autoFillWithFilling: false, autoFillUploadMode: 'files' }));
	};
	const onAccurateFolderName = () => {
		dispatch(updateFileAllocation({ autoFillContext: { enabled: false, companyId, moduleType: tab, sectionCode: null, scope: 'module', scopeName: '' }, tab }));
		dispatch(toggleModal({ open: 'autoFillStepper', autoFillStepperPhase: 'select', autoFillStatusBarPhase: 'select', autoFillWithFilling: false, autoFillUploadMode: 'folders' }));
	};
	const handleDisconnectDataRoom = async (dataroomType) => dispatch(toggleModal({ open: 'disconnectDataRoom', modalHistory: dataroomType }));

	const handleDateChange = (e, question, qNo) => {
		setDateValue((prev) => (prev, { [question._id]: e.target.value }));
		debouncedSaveAnswer(e, question, qNo);
	};

	const subFolderModules = ["repository"];
	const getSectionHTML = (module, currentSection) => {
		if (module) module = JSON.parse(JSON.stringify(module));
		if (currentSection) currentSection = JSON.parse(JSON.stringify(currentSection));
		let convert;
		if (module['type'].includes('directors-questionnaire')) convert = currentSection?.subFolders || module?.sections[0]?.subFolders;
		else convert = currentSection?.subFolders || module?.sections;
		return <>
			{convert && Object.values(convert)
				.filter(s => (currentSection?.questions || s?.questions || []).find(q => q.qNo.match(new RegExp((s.sectionNo || s.no) + "((\.[0-9]+)|$)"))))
				.slice().sort(sortSections).map((section, sectionIdx) => {
					if ((module['type'] == 'repository' || module['type'] == `business-audit-${company['testType']}`) && ((user['role'] == "Advisor" || user['role'] == "Investor") && (user?.['companyId'] && user?.['companyId']?.['_id'] != company?.['_id'])) && (company['advisors'] || company['investors']) && section?.['sectionNo']) {
						// if ((company?.['advisors']?.[user['_id']]?.['modules'] && !company?.['advisors']?.[user['_id']]?.['modules']?.[section?.['sectionNo']] && user['role'] == 'Advisor' && user?.['companyId']?.['_id'] !== company['_id']) || (!company?.['investors']?.[user['_id']]?.['modules']?.[section?.['sectionNo']] && user['role'] == 'Investor')) return;
					}

					let questions;
					let showSubFolder = false;
					const qNo = section.sectionNo || section.no;
					const sectionId = section['_id'] || section['sectionId'] || `section-${sectionIdx}`;
					if (module['expansionPack']) {
						showSubFolder = qNo.indexOf('.') < 0;
						questions = qNo.indexOf('.') > 0 ? section['questions'] : [];
						section.stats = section.stats || currentSection?.stats; // Temporary
					} else if (subFolderModules.includes(module.type)) {
						if (currentSection) section.questions = currentSection.questions;
						if (Object.values((section && section?.subFolders) || {})?.find(s => section?.questions?.find(q => q.qNo.match(new RegExp((s.sectionNo || s.no) + "(\.[0-9]+)|$")))))
							showSubFolder = true;

						questions = section.questions && section.questions.filter(q => q.qNo === qNo) || [];
					} else questions = section.questions.filter(q => q.qNo.match(new RegExp(qNo + "(\.[0-9]+)|$")));

					section.files = [];
					if (section && section['files']) section.files = getFilesFromQuestions(questions);
					// Sort all questions.					
					questions = questions && sortQuestionsByQNo(questions);
					const jsx = <>
						{questions && questions.length > 0 && questions.map((question, questionIdx) => {
							if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
							let answer = question.answer || {};
							let showFiles = answer['radioOption'] === "Yes" || answer['radioOption'] == 'Disclosure';
							let showToolBox = answer['radioOption'] === "Yes" || answer['radioOption'] == "No" || answer['radioOption'] == "N/A" || answer['radioOption'] == 'Disclosure';
							return (
								<div key={question._id} data-module-type={module.type} data-section-no={question['qNo']} data-question-id={question['_id']} className={!showSubFolder ? "bss bw2px bo5 br10px px2rem py1rem mt1rem pr" : "pr"}>
									{/* Three-dot menu for Sync, Manage Files, Generate Report, View Report and Log */}
									{(() => {
										const canSync = Boolean((section.sectionNo || section.no) && (company.gDriveLink || company.sharePointLink || company.dropBoxLink) && module['uploadFiles'] && !tab.includes('directors-questionnaire') && answer?.files?.length && tab === "repository");
										const canReport = question['isPrompt'] === true;
										const hasFiles = canReport && (question?.answer?.files && question.answer.files.length > 0) && section?.['stats']?.['completionPercent'] === 100;
										const currentKey = canReport ? getReportGenerationKey(question, true) : null;
										const isGenerating = canReport && reportGenerateLoading === currentKey;
										const isAnyGenerating = reportGenerateLoading !== null;
										const showMenu = answer?.['updatedBy'] || (showFiles && answer?.files?.length > 0) || canSync || canReport;
										if (!showMenu) return null;
										return (
											<div className="pa menuHover" style={{ top: '-10px', right: '-10px' }}>
												<button className="shadow cp bg1 br50px df jcc aic" style={{ width: '25px', height: '25px' }}>
													<span className="fs1-25rem fw600 c3" style={{ marginBottom: '12px' }}>...</span>
												</button>
												<div className="menu op0 pen zi10 bg1 br10px shadow pa r0 df fdc" style={{ minWidth: '180px', top: '22px', overflow: 'hidden' }}>
													{canSync &&
														<p onClick={() => (company.gDriveLink && syncDrive(sectionId, (question['qNo']))) || (company.sharePointLink && syncSharePoint(sectionId, (question['qNo']))) || (company.dropBoxLink && syncDropbox(sectionId, (question['qNo'])))}
															className="w100 bg5-hover fs12px c14 px1rem py0-5rem cp df aic" style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
															<img src={require('../../../../images/sync-data-room.png')} alt="sync" className="mr0-5rem" style={{ width: '16px', height: '16px' }} />
															Sync
															<span className="df aic ml0-5rem">
																{company.gDriveLink && <GoogleDrive className="pen fds ml0-25rem" style={{ width: '14px', height: '14px' }} />}
																{company.dropBoxLink && <Dropbox className="pen fds ml0-25rem" style={{ width: '14px', height: '14px' }} />}
																{company.sharePointLink && <SharePoint className="pen fds ml0-25rem" style={{ width: '14px', height: '14px' }} />}
															</span>
														</p>
													}
													{showFiles && answer?.files?.length > 0 &&
														<p onClick={() => {
															const isWarrantyDisclosure = tab === "warranty-disclosure";
															if (isWarrantyDisclosure) setSection({ ...section, questionId: question?.['qNo'], question });
															else setSection({ ...section, questionId: question?.['qNo'] });
															onClickFileManager(section, questionIdx);
															dispatch(toggleModal({ open: isWarrantyDisclosure ? 'manageWarrantyDisclosureFiles' : 'manageFiles' }));
														}} className="w100 bg5-hover fs12px c14 px1rem py0-5rem cp df aic" style={!canSync ? { borderTopLeftRadius: '10px', borderTopRightRadius: '10px' } : {}}>
															File Manager ({answer.files.length})
														</p>
													}
													{canReport &&
														<p onClick={() => hasFiles && !isAnyGenerating ? generateInsuranceAiReport({ data: question, isQuestion: true }) : undefined}
															className={`w100 bg5-hover fs12px c14 px1rem py0-5rem df aic ${hasFiles && !isAnyGenerating ? 'cp' : 'op50'}`}
															data-tooltip={!hasFiles ? "Complete the 100% section to generate the report" : ""}>
															{isGenerating ? "Generating..." : "Generate Report"}
														</p>
													}
													{canReport &&
														<Link
															onClick={(e) => { if (isAnyGenerating) { e.preventDefault(); return; } handleSectionReportLinkClick(e, section, true, question); }}
															to={hasSectionReport(section, true, question) ? `#${getSectionTabName(section, true, question)}` : "#repository"}
															className={`w100 bg5-hover fs12px c14 px1rem py0-5rem df aic td250 ${hasSectionReport(section, true, question) && !isAnyGenerating ? 'cp' : 'op50'}`}
															style={{ pointerEvents: isAnyGenerating ? 'none' : 'auto', textDecoration: 'none' }}>
															View Report
														</Link>
													}
													{answer?.['updatedBy'] &&
														<p onClick={() => { setSection({ ...section, questionId: question?.['qNo'] }); handleSectionLogs(answer['_id']); setLogModule(` - ${question['qNo']} ${section['sectionName'] || section['name']}`) }}
															className="w100 bg5-hover fs12px c14 px1rem py0-5rem cp df aic" style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
															Log
														</p>
													}
												</div>
											</div>
										);
									})()}
									<div className={`df ${(answer?.['updatedBy']) ? 'jcsb' : 'jcfe'}`}>
										{(answer?.['updatedBy']) && <div>{answerSaved(answer)}</div>}
									</div>
									<div data-module-type={module.type} data-section-no={qNo} data-question-id={question['_id']} className={((question.editPermission ?? true) ? "" : "op20 pen ") + "dg gg2rem report-upload-area-saf aifs"} style={{ gridTemplateColumns: '55% auto' }}>
										<div className={isTwoMinuteTesHomePage && `df fww aifs`}>
											<div>
												<div className="df aic fww gg0-5rem">
													<span className="fs1rem c15 fw500">{question['qNo']}</span>
													{(!answer.radioOption || answer.radioOption === 'NC') && (!answer.status || answer.status === 'Not Started') &&
														<span className="br50px px0-75rem py0-25rem fs12px fw500" style={{ background: '#e8eaf6', color: '#6b7280' }}>Not Started</span>
													}
													<p className="w100 fw400 fs14px c15 mb0">{question.qDescription}</p>
												</div>
												{(() => {
													const options = question.questionType === 'yesNo' ? ['Yes', 'No', 'N/A']
														: question.questionType === '1to5' ? [1, 2, 3, 4, 5]
															: question.questionType == 'D/ND' ? ['Disclosure', 'No Disclosure', 'Not Sure', 'N/A']
																: ['Yes', 'No', 'N/A'];
													return (
														<>{module['type'].includes("directors-questionnaire") || module['type'].includes("investor-lead")
															? <>
																{question?.questionType.includes("YN") &&
																	<div className="df aic fww">
																		{options.map((option, optIdx) =>
																			<label key={`${question._id}-yn-${option}-${optIdx}`} for={question._id + option} className="py1rem df cp fs0-75rem">
																				<span className="checkbox w30px h30px pr">
																					<input
																						defaultChecked={answer.radioOption == option}
																						data-option={option} id={question._id + option + answer.radioOption}
																						onChange={(e) => radioButtonChanged(e, question, qNo, module.type)}
																						name={question._id}
																						className="bg1 bo4 bw2px bss cp td250 w30px h30px br5px"
																						key={`${question._id}-${option}-${answer.radioOption}`}
																						type="radio"
																					/>
																				</span>
																				<span className="w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500">{option}</span>
																			</label>)
																		}
																	</div>
																}
																{question?.questionType.includes("DropDown") &&
																	<div className="oyh td250 pr mt1rem">
																		<select value={answer?.dropdown} name="dropdown" className="pl1rem bss bw2px bo5 w90 br5px p1rem" onChange={(e) => saveAnswer(e, question, qNo)}>
																			<option value={answer?.dropdown} selected disabled hidden>{answer?.dropdown}</option>
																			{module['type'].includes("investor-lead")
																				? question['options'] && question['options'].map((option, idx) => <option key={idx} value={option['name'].replaceAll("'", ',')}>{option['name'].replaceAll("'", ',')}</option>)
																				: question['options'] && question['options'].map((option, idx) => <option key={idx} value={option['name']}>{option['name']}</option>)
																			}
																		</select>
																	</div>
																}
																{question?.questionType.includes("Date") &&
																	<div className="oyh td250 pr mt1rem">
																		<input
																			value={dateValue[question['_id']] || (answer?.date && (new Date(answer?.date).toISOString().substring(0, 10)))}
																			type="date"
																			name="date"
																			className="pl2rem bss bw2px bo5 w90 br5px p1rem"
																			onChange={(e) => handleDateChange(e, question, qNo)}
																			max={new Date().toISOString().substring(0, 10)}
																		/>
																	</div>
																}

																{question?.questionType.includes("Radio") &&
																	<div className="df aic fww">
																		{question['options'].map((option, optIdx) =>
																			<label key={`${question._id}-radio-${option['name']}-${optIdx}`} for={question._id + option['name']} className="py1rem df cp fs0-75rem">
																				<span className="checkbox checkbox-border-qus w30px h30px pr">
																					<input defaultChecked={answer['dropdown'] == option['name']} data-option={option['name']} onChange={(e) => saveAnswer(e, question, qNo)} name={question._id} id={question._id + option['name']} className="bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px" type="radio" key={`${question._id}-${option}-${answer['dropdown']}`} />
																				</span>
																				<span className="w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500">{option['name']}</span>
																			</label>)
																		}
																	</div>
																}
																{question?.questionType.includes("Multi") &&
																	<div className="multi-dropdown mt1rem">
																		<Select
																			multiple
																			className="w400px"
																			placeholder="Select any options from dropdown"
																			name="dropdown"
																			id="demo-multiple-checkbox"
																			labelId="demo-multiple-checkbox-label"
																			onChange={(e) => saveAnswer(e, question, qNo)}
																			renderValue={(selected) => selected.join(',  ')}
																			value={question['answer']['dropdown'] ? question['answer']['dropdown']?.split(";") : []}>
																			{question['options'].map((option, idx) => (
																				<MenuItem value={option['name']} className="multi-dropdown-list">
																					<Checkbox checked={question['answer']?.['dropdown']?.split(";").indexOf(option['name']) > -1} />
																					<ListItemText primary={option['name']} />
																				</MenuItem>
																			))}
																		</Select>
																	</div>
																}
															</>
															: <div className="df aic fww ml1rem">
																{options.map((option, optIdx) =>
																	<div key={`${question._id}-option-${option}-${optIdx}`}>
																		<label for={question._id + option} className={`df cp fs0-75rem ${question.questionType === '1to5' && (option == 1 || option == 5) ? 'pt2rem pb0-5rem' : 'py1rem'}`}>
																			<span className="checkbox w20px h20px pr">
																				<input
																					defaultChecked={answer.radioOption == option}
																					data-option={option}
																					onChange={(e) => radioButtonChanged(e, question, qNo, module.type)}
																					name={question._id}
																					disabled={isSaving}
																					id={question._id + option + answer.radioOption}
																					className="bg1 bo4 bw1px bss cp td250 w20px h20px br5px" type="radio"
																					key={`${question._id}-${option}-${answer.radioOption}`}
																				/>
																			</span>
																			<span className="w100 fs0-75rem c15 lh3 ml0-5rem usn mr1-5rem fw500">{option}</span>
																		</label>
																		{(question.questionType === '1to5' && option == 1) && <span className="c9 fs0-75rem">Poor</span>}
																		{(question.questionType === '1to5' && option == 5) && <span className="c7 fs0-75rem">Excellent</span>}
																	</div>
																)}
															</div>
														}
														</>
													)
												})()}
												{!([`business-audit-${company['testType']}`, `two-minute-test-${company['testType']}`].includes(module['type'])) && module.stats.completionPercent == 100 && answer.radioOption === "No" &&
													["riskDescription", "recommendDescription"].filter(key => question[key]).map(key => (
														<div key={`${question._id}-${key}`} className={"recommendation"}>
															{showRiskRecommendation(key)}
															{question[key].split(/\n/).map((s, i) => <p key={`${question._id}-${key}-line-${i}`} className="mt1rem c15 fs14px">{s}</p>)}
														</div>
													))}
												{module['type'].includes(`business-audit-${company['testType']}`) && answer.radioOption === "No" &&
													["riskDescription", "recommendDescription"].filter(key => answer?.aiResponse && answer?.aiResponse['if' + key]).map(key => (
														<div key={`${question._id}-ai-${key}`} className={"recommendation"}>
															{showRiskRecommendation(key)}
															{answer.aiResponse['if' + key].split(/\n/).map((s, i) => <p key={`${question._id}-ai-${key}-line-${i}`} className="mt1rem c15 fs14px">{s}</p>)}
														</div>
													))}
												{module?.['type'] && company?.['testType'] && module['type'] == `two-minute-test-${company['testType']}` && module?.['stats']?.['completionPercent'] == 100 &&
													<>{["Yes", "No", 1, 2, 3, 4, 5].filter(key =>
														(question?.['answer']?.['aiResponse'] ? question['answer']['aiResponse']["if" + key] : question["if" + key])).map(key => (
															<div key={`${question._id}-twomin-${key}`} className={"recommendation" + ((answer.radioOption) == key ? "" : " dn")}>
																{showRiskRecommendation('recommend')}
																{question?.['answer']?.['aiResponse']
																	? <>{question['answer']['aiResponse']["if" + key].split(/\n/).map((s, i) => <p key={`${question._id}-twomin-ai-${key}-line-${i}`} className="mt1rem c15 fs14px">{s}</p>)}</>
																	: <>{question["if" + key].split(/\n/).map((s, i) => <p key={`${question._id}-twomin-${key}-line-${i}`} className="mt1rem c15 fs14px">{s}</p>)}</>
																}
															</div>
														))}</>
												}
												{(question.topTip || question['toolboxOffer']) && (
													<div className={`${isTwoMinuteTesHomePage && (sectionIdx == 0 && questionIdx == 0) && "op60"} w80 bss bw1px bo5 br10px mt1rem fs0-75rem`}>
														{/* Header — always visible, click to toggle */}
														<div className="df aic jcsb px1rem py0-5rem cp" onClick={() => toggleToolbox(question._id)} style={{ background: '#b5bfde52', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
															<div className="df aic">
																<img src={require('../../../../images/toolbox-icon.png')} alt="toolbox" className="w20px h20px mr0-5rem" />
																<h4 className="c15 mb0">Toolbox</h4>
															</div>
															<svg className="c15" style={{ transition: 'transform 0.2s', transform: openToolboxes[question._id] === true ? 'rotate(180deg)' : 'rotate(0deg)' }} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
															</svg>
														</div>
														{/* Collapsible body — closed by default */}
														{openToolboxes[question._id] === true && (
															<div className="px1rem pb1rem" style={{ backgroundColor: '#f3f5ff', borderTop: '1px solid #e5e7eb', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
																{question.topTip && (
																	<>
																		<p className="fw600 c15 mt0-5rem mb0-25rem">Tip</p>
																		<p className="c37 mb0-5rem">{question.topTip}</p>
																	</>
																)}
																{question['toolboxOffer'] && (
																	<>
																		<p className="fw600 c15 mb0-25rem">Offer</p>
																		<p className="c15 mb0-5rem">{question['toolboxOffer']}</p>
																	</>
																)}
																<div className="df gg0-5rem mt0-5rem">
																	<button className="new-shadow df aic bg1 c15 br50px px0-75rem py0-25rem fw400 fs0-75rem cna op50">
																		<img src={require('../../../../images/double-star-icon.png')} alt="double-star-icon" className="w20px h20px mr0-5rem" />
																		Analyser
																	</button>
																	<button className="new-shadow df aic bg1 c15 br50px px0-75rem py0-25rem fw400 fs0-75rem cna op50">
																		<img src={require('../../../../images/double-star-icon.png')} alt="double-star-icon" className="w20px h20px mr0-5rem" />
																		PolicyMaker
																	</button>
																</div>
															</div>
														)}
													</div>
												)}
											</div>
											{/* 2-Minute Test Dummy Image   */}

											{question.templateFiles && question.templateFiles.length > 0 && <div className={(showFiles ? "" : "op0 h0 dn ") + "showOrHide df fww mt0-5rem"}>
												{question.templateFiles.map((file, fileIdx) => <a key={`template-file-${question._id}-${fileIdx}-${file.originalname}`} className="df jcc aic br5px lh1 bg4 c1 px0-5rem fw600 mr0-5rem mb0-5rem" target="_blank" href={file.location}>
													<span className="py0-5rem pl0-5rem">{file.originalname}</span>
												</a>)}
											</div>}
										</div>

										<div>
											<div className="df jcfe gg0-5rem mb1rem fww aic">
												{/* <button className="cp df aic px0-75rem py0-25rem c15 fs12px fw400 bg1 bw1px bss bo16 br20px" onClick={() => setWorkflowModalData({ question, section, answer, module })}>
													<svg className="mr0-5rem" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M11 0C4.93436 0 0 4.93436 0 11C0 17.0656 4.93436 22 11 22C17.0656 22 22 17.0656 22 11C22 4.93436 17.0656 0 11 0Z" fill="#4A67FF" fillOpacity="0.1" />
														<g clipPath="url(#clip0_6001_3097)">
															<path d="M4.1789 13.6959L3.57812 17.3003L15.1925 18.9999L15.2917 18.2095L16.3755 7.80139L5.33536 6.07617L4.1789 13.6959Z" fill="#EABB39" />
															<path d="M17.4184 5.33881L16.052 18.2932L9.59044 17.5949C9.58738 17.5947 9.58738 17.5947 9.58738 17.5947C9.57291 17.5874 9.55509 17.5802 9.53783 17.5699C6.22797 16.0663 3.85938 13.5161 3.85938 13.5161L5.0214 4L17.4184 5.33881Z" fill="#FFD858" />
															<path d="M9.53755 17.5698C6.22769 16.0687 3.85938 13.516 3.85938 13.516C3.85938 13.516 5.91728 13.4517 7.21684 12.7964C7.45152 14.011 8.2238 15.979 9.53755 17.5698Z" fill="#DDAC33" />
															<path d="M6.24219 7.65723L6.30566 7.10377L15.6377 8.17405L15.5742 8.7275L6.24219 7.65723Z" fill="white" />
															<path d="M5.96875 9.52441L6.03 8.97096L13.2265 9.76736L13.1653 10.3208L5.96875 9.52441Z" fill="white" />
															<path d="M5.70312 11.3936L5.76827 10.8407L14.828 11.9081L14.7629 12.461L5.70312 11.3936Z" fill="white" />
														</g>
														<defs><clipPath id="clip0_6001_3097"><rect width="15" height="15" fill="white" transform="translate(3 4)" /></clipPath></defs>
													</svg>
													Workflow
												</button> */}
												<label htmlFor={question._id + "complete"} className="cp df aic">
													<input disabled={isSaving} defaultChecked={answer.status === "Completed"} onChange={(e) => saveAnswer(e, question, qNo)} name="status" id={question._id + "complete"} className="dn" type="checkbox" key={`${question._id}-Completed-${answer.status}`} />
													<span className={`df aic br20px px0-75rem py0-5rem fs12px fw400 ${answer.status === 'Completed' ? 'bg34 c1' : 'bg1 bss bw1px bo16 c12'}`}>
														<i className="fa fa-check mr0-5rem" /> {answer.status === 'Completed' ? 'Completed' : 'Mark as Complete'}
													</span>
												</label>
												{!isTwoMinuteTesHomePage && answer.status !== "Completed" && (
													<AutoFillButton
														companyId={companyId}
														moduleType={module.type}
														sectionCode={qNo}
														questionId={question._id}
														qNo={question.qNo}
														scope="question"
														size="small"
														onComplete={() => { reloadModule && reloadModule(tab); }}
													/>
												)}
												{answer.status === 'Completed' && (
													<button
														type="button"
														disabled={isSaving}
														onClick={() => saveAnswer({ target: { name: 'isReviewed', value: !answer.isReviewed, type: 'text', dataset: {} } }, question, qNo)}
														className={`df aic br20px px0-75rem py0-5rem fs12px fw400 cp ${answer.isReviewed ? 'bg34 c1' : 'bg1 bss bw1px bo16 c12'}`}
													>
														<svg className="mr0-5rem" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M12 5C7 5 2.73 8.11 1 12.5C2.73 16.89 7 20 12 20C17 20 21.27 16.89 23 12.5C21.27 8.11 17 5 12 5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
															<circle cx="12" cy="12.5" r="3" stroke="currentColor" strokeWidth="2" fill="none"/>
														</svg>
														{answer.isReviewed ? 'Reviewed' : 'Review'}
													</button>
												)}
											</div>

										{isTwoMinuteTesHomePage && ((sectionIdx == 0 && questionIdx == 0) ?
											<div className='two-min-invest-image op80'>
												<div className="df aic mb1rem op80">
													<span className="ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem">Sync</span>
													<span className="ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem">File Manager</span>
													<span className="ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem">Log</span>
												</div>
												<div className={"oyh td250"}>
													<label for={"fileUpload" + new Date().getTime()} className="w100 bsbb bg50 br5px df jcc fdc aic px1rem py0-5rem bsd bo3 bw2px da-cursor mb0-5rem">
														<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M59.4632 31.0446C58.5439 25.1606 53.4429 20.6445 47.3047 20.6445C44.9955 20.6445 42.7766 21.2834 40.852 22.4751C37.924 17.5543 32.6528 14.4922 26.7969 14.4922C17.7506 14.4922 10.3906 21.8522 10.3906 30.8984C10.3906 30.9545 10.3906 31.0126 10.3927 31.0687C4.57871 32.048 0 37.1168 0 43.2031C0 49.9883 5.65619 55.5078 12.4414 55.5078H57.5586C64.3438 55.5078 70 49.9883 70 43.2031C70 37.0649 65.3472 31.9639 59.4632 31.0446Z" fill="white" />
															<g clip-path="url(#clip0_5984_51759)">
																<path d="M35 56C42.732 56 49 49.732 49 42C49 34.268 42.732 28 35 28C27.268 28 21 34.268 21 42C21 49.732 27.268 56 35 56Z" fill="#4A67FF" />
																<path d="M34.9896 49.6555C33.746 49.6555 32.5026 49.6555 31.2593 49.6555C29.5542 49.6555 28.3237 48.4294 28.315 46.7248C28.3117 46.1298 28.3117 45.5346 28.315 44.9392C28.3182 44.3256 28.6901 43.9308 29.2589 43.9297C29.8276 43.9286 30.2044 44.3207 30.2082 44.9338C30.2121 45.5468 30.2082 46.1456 30.2082 46.7516C30.2126 47.387 30.5861 47.7573 31.2238 47.7578C33.7427 47.7578 36.2614 47.7578 38.78 47.7578C39.4182 47.7578 39.7922 47.387 39.7971 46.7521C39.8015 46.1462 39.7971 45.5402 39.7971 44.9343C39.7971 44.3284 40.175 43.9286 40.746 43.9297C41.3169 43.9308 41.6943 44.3256 41.6893 44.9387C41.6833 45.7136 41.7265 46.4967 41.6292 47.2613C41.4509 48.6602 40.2582 49.6478 38.8429 49.6544C37.5615 49.6582 36.2753 49.6555 34.9896 49.6555Z" fill="white" />
																<path d="M34.0577 37.6102C33.9133 37.7448 33.8286 37.8186 33.7498 37.8979C33.1439 38.5098 32.5412 39.1256 31.9325 39.7354C31.5005 40.1685 30.8984 40.2002 30.5079 39.8212C30.1175 39.4423 30.1328 38.8205 30.5577 38.3928C31.7947 37.1481 33.0358 35.9078 34.2808 34.6719C34.7183 34.2344 35.2904 34.2344 35.7279 34.6719C36.9813 35.9151 38.2296 37.1636 39.4729 38.4174C39.8819 38.8303 39.8841 39.451 39.504 39.8218C39.124 40.1926 38.5197 40.1762 38.1024 39.7622C37.4844 39.147 36.8758 38.5219 36.2622 37.9028C36.1829 37.823 36.0981 37.7486 35.9718 37.6294C35.9636 37.8011 35.9537 37.9121 35.9537 38.0231C35.9537 39.9804 35.9565 41.9371 35.9537 43.8944C35.9537 44.6288 35.3073 45.0658 34.6352 44.8044C34.2633 44.6595 34.0615 44.3368 34.0615 43.8643C34.0593 41.9284 34.0593 39.9926 34.0615 38.057L34.0577 37.6102Z" fill="white" />
															</g>
															<defs>
																<clipPath id="clip0_5984_51759">
																	<rect width="28" height="28" fill="white" transform="translate(21 28)" />
																</clipPath>
															</defs>
														</svg>
														<span className="pen fs1rem fw400 c49 tac op80 mt1rem mb1rem fsi">
															Click here or drag and drop files (max 100MB)
														</span>
													</label>
													<div className="oyh td250 pr df aic ">
														<textarea
															rows="1"
															style={{ resize: "vertical", fontSize: "12px", height: "100px" }}
															name="comment"
															type="text"
															disabled
															placeholder="Add notes"
															className="pl3rem bss bw2px bo5 w100 br5px pr1rem py0-75rem"
														>
														</textarea>
														<svg className="pa ml1rem" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_5984_51771)">
																<path d="M14.25 8.25H9.75V3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75V8.25H3.75C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75H8.25V14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25V9.75H14.25C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25Z" fill="#4A67FF" />
																<g clip-path="url(#clip1_5984_51771)">
																	<path d="M16.7301 14.3415L4.73098 17.2387C4.09339 17.3926 3.45171 17.0005 3.29776 16.3629L0.400638 4.36379C0.246685 3.7262 0.638767 3.08452 1.27636 2.93057L13.2755 0.0334501C13.9131 -0.120503 14.5548 0.27158 14.7087 0.909168L17.6059 12.9083C17.7598 13.5459 17.3678 14.1876 16.7301 14.3415Z" fill="url(#paint0_linear_5984_51771)" />
																	<path d="M14.3672 14.9115L16.7313 14.3407C17.3688 14.1868 17.7609 13.5451 17.607 12.9075L15.3723 3.65234H14.3672V14.9115Z" fill="url(#paint1_linear_5984_51771)" />
																	<path d="M15.3863 3.72331L14.7068 0.909168C14.5529 0.271579 13.9112 -0.120503 13.2736 0.0334501L1.27447 2.93057C0.856593 3.03147 0.54424 3.34185 0.421875 3.72331H15.3863Z" fill="url(#paint2_linear_5984_51771)" />
																	<path d="M1.85156 10.3629L3.30014 16.3624C3.45409 17 4.09574 17.3921 4.73336 17.2382L16.7325 14.341C17.3701 14.1871 17.7622 13.5454 17.6082 12.9078L16.1597 6.9082L1.85156 10.3629Z" fill="url(#paint3_linear_5984_51771)" />
																	<path d="M11.3983 17.9993H1.36905C0.815741 17.9993 0.367188 17.5508 0.367188 16.9975L0.376011 3.92377C0.376011 3.37046 0.824564 2.92188 1.37787 2.92188H14.4486C15.0019 2.92188 15.4505 3.37043 15.4505 3.92377L15.4417 13.956C15.4417 16.1891 13.6314 17.9993 11.3983 17.9993Z" fill="url(#paint4_linear_5984_51771)" />
																	<path d="M8.50558 4.14062L7.3125 5.33371L10.9873 9.00846C11.5559 8.8328 12.0046 8.38404 12.1803 7.81538L8.50558 4.14062Z" fill="url(#paint5_linear_5984_51771)" />
																	<path d="M7.90614 5.57985C8.37206 5.57985 8.74977 5.20214 8.74977 4.73621C8.74977 4.27029 8.37206 3.89258 7.90614 3.89258C7.44021 3.89258 7.0625 4.27029 7.0625 4.73621C7.0625 5.20214 7.44021 5.57985 7.90614 5.57985Z" fill="url(#paint6_linear_5984_51771)" />
																	<path d="M0.367188 10.6563V16.9965C0.367188 17.5498 0.815741 17.9983 1.36905 17.9983H11.3983C13.6314 17.9983 15.4417 16.1881 15.4417 13.955V10.6562H0.367188V10.6563Z" fill="url(#paint7_linear_5984_51771)" />
																	<path d="M11.3984 17.9984V14.957C11.3984 14.4037 11.847 13.9551 12.4003 13.9551H15.4418C15.4418 16.1882 13.6315 17.9984 11.3984 17.9984Z" fill="url(#paint8_linear_5984_51771)" />
																	<path d="M13.0689 9.20312H7.28104C7.07404 9.20312 6.90625 9.37091 6.90625 9.57791C6.90625 9.78491 7.07404 9.9527 7.28104 9.9527H13.0689C13.2759 9.9527 13.4437 9.78491 13.4437 9.57791C13.4437 9.37091 13.2759 9.20312 13.0689 9.20312Z" fill="white" />
																	<path d="M2.74979 9.9527H4.44885C4.65585 9.9527 4.82364 9.78491 4.82364 9.57791C4.82364 9.37091 4.65585 9.20312 4.44885 9.20312H2.74979C2.54279 9.20312 2.375 9.37091 2.375 9.57791C2.375 9.78491 2.54279 9.9527 2.74979 9.9527Z" fill="white" />
																	<path d="M5.375 9.57791C5.375 9.78491 5.54279 9.9527 5.74979 9.9527H6.17455C6.38155 9.9527 6.54934 9.78491 6.54934 9.57791C6.54934 9.37091 6.38155 9.20312 6.17455 9.20312H5.74979C5.54282 9.20312 5.375 9.37091 5.375 9.57791Z" fill="white" />
																	<path d="M8.53764 10.9688H2.74979C2.54279 10.9688 2.375 11.1365 2.375 11.3435C2.375 11.5505 2.54279 11.7183 2.74979 11.7183H8.53764C8.74464 11.7183 8.91242 11.5505 8.91242 11.3435C8.91242 11.1365 8.74464 10.9688 8.53764 10.9688Z" fill="white" />
																	<path d="M13.066 10.9688H11.367C11.16 10.9688 10.9922 11.1365 10.9922 11.3435C10.9922 11.5505 11.16 11.7183 11.367 11.7183H13.066C13.273 11.7183 13.4408 11.5505 13.4408 11.3435C13.4408 11.1365 13.273 10.9688 13.066 10.9688Z" fill="white" />
																	<path d="M10.073 10.9688H9.64823C9.44123 10.9688 9.27344 11.1365 9.27344 11.3435C9.27344 11.5505 9.44123 11.7183 9.64823 11.7183H10.073C10.28 11.7183 10.4478 11.5505 10.4478 11.3435C10.4478 11.1365 10.28 10.9688 10.073 10.9688Z" fill="white" />
																</g>
															</g>
															<defs>
																<linearGradient id="paint0_linear_5984_51771" x1="4.64913" y1="5.97348" x2="20.2804" y2="15.518" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#D9B1EE" />
																	<stop offset="1" stop-color="#814AA0" />
																</linearGradient>
																<linearGradient id="paint1_linear_5984_51771" x1="16.8003" y1="9.28193" x2="15.1027" y2="9.28193" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#5B3374" stop-opacity="0" />
																	<stop offset="1" stop-color="#5B3374" />
																</linearGradient>
																<linearGradient id="paint2_linear_5984_51771" x1="7.90405" y1="1.33693" x2="7.90405" y2="3.53614" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#5B3374" stop-opacity="0" />
																	<stop offset="1" stop-color="#5B3374" />
																</linearGradient>
																<linearGradient id="paint3_linear_5984_51771" x1="10.1943" y1="13.541" x2="11.0307" y2="17.0005" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#5B3374" stop-opacity="0" />
																	<stop offset="1" stop-color="#5B3374" />
																</linearGradient>
																<linearGradient id="paint4_linear_5984_51771" x1="0.973999" y1="3.52579" x2="14.9207" y2="17.4724" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FFDD00" />
																	<stop offset="1" stop-color="#FFB000" />
																</linearGradient>
																<linearGradient id="paint5_linear_5984_51771" x1="9.96461" y1="6.7927" x2="5.00606" y2="1.83419" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FEA613" stop-opacity="0" />
																	<stop offset="1" stop-color="#E94444" />
																</linearGradient>
																<linearGradient id="paint6_linear_5984_51771" x1="7.37934" y1="4.20938" x2="8.24118" y2="5.07123" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FE93BB" />
																	<stop offset="1" stop-color="#FD3581" />
																</linearGradient>
																<linearGradient id="paint7_linear_5984_51771" x1="7.90442" y1="15.5917" x2="7.90442" y2="19.8029" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FEA613" stop-opacity="0" />
																	<stop offset="1" stop-color="#E94444" />
																</linearGradient>
																<linearGradient id="paint8_linear_5984_51771" x1="12.3144" y1="14.8711" x2="14.6838" y2="17.2404" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FFDD00" />
																	<stop offset="1" stop-color="#FFB000" />
																</linearGradient>
																<clipPath id="clip0_5984_51771">
																	<rect width="18" height="18" fill="white" />
																</clipPath>
																<clipPath id="clip1_5984_51771">
																	<rect width="18" height="18" fill="white" />
																</clipPath>
															</defs>
														</svg>
													</div>
												</div>
											</div> : <>
												<div className='two-min-invest-image'>
													<label
														for={"fileUpload" + new Date().getTime()}
														className="w100 bsbb bg50 br5px df jcfs aic px0-5rem py1rem bsd bo3 bw2px da-cursor mb0-5rem op60"
													>
														<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_5984_51832)">
																<path d="M18.75 24.5H5.25C4.01 24.5 3 23.491 3 22.25V11.75C3 10.509 4.01 9.5 5.25 9.5H18.75C19.99 9.5 21 10.509 21 11.75V22.25C21 23.491 19.99 24.5 18.75 24.5ZM5.25 11C4.837 11 4.5 11.336 4.5 11.75V22.25C4.5 22.664 4.837 23 5.25 23H18.75C19.163 23 19.5 22.664 19.5 22.25V11.75C19.5 11.336 19.163 11 18.75 11H5.25Z" fill="#4A67FF" />
																<path d="M17.25 11C16.836 11 16.5 10.664 16.5 10.25V6.5C16.5 4.019 14.481 2 12 2C9.519 2 7.5 4.019 7.5 6.5V10.25C7.5 10.664 7.164 11 6.75 11C6.336 11 6 10.664 6 10.25V6.5C6 3.191 8.691 0.5 12 0.5C15.309 0.5 18 3.191 18 6.5V10.25C18 10.664 17.664 11 17.25 11Z" fill="#4A67FF" />
																<path d="M12 17.5C10.897 17.5 10 16.603 10 15.5C10 14.397 10.897 13.5 12 13.5C13.103 13.5 14 14.397 14 15.5C14 16.603 13.103 17.5 12 17.5ZM12 15C11.725 15 11.5 15.224 11.5 15.5C11.5 15.776 11.725 16 12 16C12.275 16 12.5 15.776 12.5 15.5C12.5 15.224 12.275 15 12 15Z" fill="#4A67FF" />
																<path d="M12 20.5C11.586 20.5 11.25 20.164 11.25 19.75V17C11.25 16.586 11.586 16.25 12 16.25C12.414 16.25 12.75 16.586 12.75 17V19.75C12.75 20.164 12.414 20.5 12 20.5Z" fill="#4A67FF" />
															</g>
															<defs>
																<clipPath id="clip0_5984_51832">
																	<rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
																</clipPath>
															</defs>
														</svg>
														<div className="df fdc jcfs aifs ml1rem">
															<div className="pen fs1rem tal fw500 w100 c3 op80 m0rem fsi"> Register to access more features </div>
															<div className="fs13px tal w100 fsi">{(sectionIdx === 0 && [1, 2].includes(questionIdx)) ? "(No credit card required)" : "Tools Tip, Add files, Sync, File manager, Log"}</div>
														</div>
														<input disabled className="dn" id={"fileUpload" + new Date().getTime()} type="file" multiple />
													</label>
												</div>
											</>)
										}

										{module['uploadFiles'] && <>
											{module['type'].includes("directors-questionnaire") || module['type'].includes("investor-lead")
												? <div>
													{question?.questionType.includes("F") &&
														<div className={(question?.questionType.includes("YN") && (showFiles ? "" : "op0 h0 dn ")) + "showOrHide oyh td250 oxh p1rem px1-5rem br10px"} style={{ background: '#F3F5FF' }}>
															<div className="df aic jcsb mb0-5rem cp" onClick={() => setUploadOpenMap(prev => ({ ...prev, [question._id]: prev[question._id] !== false ? false : true }))}>
																<div className="df aic">
																	<svg className='mr0-5rem' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<g clipPath="url(#clip0_6001_294_dq)"><path d="M4.85746 16.7168C2.75033 14.9386 2.60107 11.6378 4.52471 9.35828L9.75741 3.15748C10.9943 1.69173 13.1027 1.43054 14.4565 2.57298C15.8103 3.71542 15.9073 5.83769 14.6704 7.30344L9.68688 13.209C9.27425 13.6979 8.57252 13.7852 8.12052 13.4038C7.66853 13.0224 7.63658 12.316 8.04922 11.827L13.0327 5.92146C13.4454 5.43248 13.4123 4.72514 12.9614 4.34464C12.5105 3.96413 11.8077 4.05049 11.3951 4.53947L6.16237 10.7403C5.06301 12.043 5.14829 13.9289 6.35252 14.9451C7.55675 15.9613 9.43012 15.7283 10.5295 14.4256L17.2572 6.45311C17.6699 5.96414 18.3716 5.87685 18.8236 6.25828C19.2756 6.63971 19.3075 7.34612 18.8949 7.8351L12.1671 15.8076C10.2435 18.0871 6.96459 18.4949 4.85746 16.7168Z" fill="#4A67FF" /></g>
																		<defs><clipPath id="clip0_6001_294_dq"><rect width="20" height="20" fill="white" /></clipPath></defs>
																	</svg>
																	<p className="fs16px c14 fw400 mb0">Files <span className="fs14px c12">({answer.files ? answer.files.length : 0})</span></p>
																</div>
																<svg style={{ transition: 'transform 0.2s', transform: uploadOpenMap[question._id] !== false ? 'rotate(180deg)' : 'rotate(0deg)' }} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path d="M6 9l6 6 6-6" stroke="#4A67FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																</svg>
															</div>
															{uploadOpenMap[question._id] !== false && <label onDragOver={onDragOver} onDrop={(e) => onDrop(e, question, qNo)} htmlFor={"fileUpload" + question._id} className="w100 bg1 br10px df jcc fdc aic px2rem py0-5rem cp mb0-5rem" style={{ border: '2px dotted #d2d2d2' }}>
																<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path d="M33.979 17.7398C33.4537 14.3775 30.5388 11.7969 27.0312 11.7969C25.7117 11.7969 24.4438 12.162 23.344 12.8429C21.6709 10.031 18.6588 8.28125 15.3125 8.28125C10.1432 8.28125 5.9375 12.487 5.9375 17.6562C5.9375 17.6883 5.9375 17.7215 5.93867 17.7535C2.61641 18.3131 0 21.2096 0 24.6875C0 28.5648 3.23211 31.7188 7.10938 31.7188H32.8906C36.7679 31.7188 40 28.5648 40 24.6875C40 21.1799 37.3413 18.2651 33.979 17.7398Z" fill="#F3F5FF" />
																	<g clipPath="url(#clip0_6001_237_dq)">
																		<path d="M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z" fill="#4A67FF" />
																		<path d="M19.9952 28.3744C19.2845 28.3744 18.574 28.3744 17.8636 28.3744C16.8892 28.3744 16.1861 27.6738 16.1811 26.6997C16.1792 26.3597 16.1792 26.0196 16.1811 25.6794C16.183 25.3288 16.3955 25.1032 16.7205 25.1025C17.0455 25.1019 17.2608 25.326 17.263 25.6763C17.2652 26.0266 17.263 26.3688 17.263 26.715C17.2655 27.0782 17.4789 27.2897 17.8433 27.29C19.2827 27.29 20.7219 27.29 22.1611 27.29C22.5258 27.29 22.7395 27.0782 22.7423 26.7154C22.7448 26.3691 22.7423 26.0229 22.7423 25.6766C22.7423 25.3304 22.9583 25.1019 23.2845 25.1025C23.6108 25.1032 23.8264 25.3288 23.8236 25.6791C23.8202 26.1219 23.8448 26.5694 23.7892 27.0063C23.6873 27.8057 23.0058 28.37 22.197 28.3738C21.4648 28.376 20.7298 28.3744 19.9952 28.3744Z" fill="#F3F5FF" />
																		<path d="M19.4627 21.4916C19.3802 21.5684 19.3317 21.6106 19.2867 21.6559C18.9405 22.0056 18.5961 22.3575 18.2483 22.7059C18.0014 22.9534 17.6573 22.9716 17.4342 22.755C17.2111 22.5384 17.2198 22.1831 17.4627 21.9387C18.1695 21.2275 18.8787 20.5188 19.5902 19.8125C19.8402 19.5625 20.167 19.5625 20.417 19.8125C21.1333 20.5229 21.8466 21.2364 22.557 21.9528C22.7908 22.1888 22.792 22.5434 22.5748 22.7553C22.3577 22.9672 22.0123 22.9578 21.7739 22.7213C21.4208 22.3697 21.073 22.0125 20.7223 21.6588C20.677 21.6131 20.6286 21.5706 20.5564 21.5025C20.5517 21.6006 20.5461 21.6641 20.5461 21.7275C20.5461 22.8459 20.5477 23.9641 20.5461 25.0825C20.5461 25.5022 20.1767 25.7519 19.7927 25.6025C19.5802 25.5197 19.4648 25.3353 19.4648 25.0653C19.4636 23.9591 19.4636 22.8529 19.4648 21.7469L19.4627 21.4916Z" fill="#F3F5FF" />
																	</g>
																	<defs><clipPath id="clip0_6001_237_dq"><rect width="16" height="16" fill="white" transform="translate(12 16)" /></clipPath></defs>
																</svg>
																<span className="op80 pen fs0-75rem fw400 c12 tac mt0-5rem fsi">Click here or drag and drop files (max 100MB)</span>
																<input onChange={(e) => saveAnswer(e, question, qNo)} className="dn" id={"fileUpload" + question._id} type="file" multiple />
															</label>}
															{uploadOpenMap[question._id] !== false && <>
																{answer.files && answer.files.length > 0 && <p className="fw500 c12 mt1rem fs0-75rem">Attached Files</p>}
																<div className="df fdc w100" style={{ maxHeight: '20vh', overflow: 'auto' }}>
																	{answer.files && answer.files.map((file, fileIndex) => {
																		let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${AppMode === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
																		return (
																			<div key={`allocated-file-${question._id}-${fileIndex}-${file.key || file.originalname}`} className="df aic py0-5rem bg1 px1rem br20px mt0-5rem" style={{ maxWidth: 'max-content' }}>
																				<div className="df aic cp" onClick={() => getViewableURL(file.location)}>
																					<span className={`br50px mr0-5rem ${fileColor}`} style={{ width: '10px', height: '10px', minWidth: '10px', flexShrink: 0 }} />
																					<span className="fw500 c14 fs12px">{file.originalname && file.originalname.length > 40 ? file.originalname.slice(0, 40) + '...' : file.originalname}</span>
																				</div>
																				<i className="fa fa-trash-o cp c23 ml3rem" onClick={e => { e.preventDefault(); setDeleteFileQuestionId(question._id); setDeleteFile(file); dispatch(toggleModal({ open: 'deleteFile', from: '' })) }} />
																			</div>)
																	})}
																</div>
															</>
															}
														</div>
													}
													{question?.questionType.includes("T") &&
														<>{module['type'].includes("investor-lead") && question['qNo'] == "DEPF008.3.1"
															? <div className="mah40vh oa oyh td250 pr mt1rem">
																{question?.['subQuestions'] && question['subQuestions'].length > 0
																	? <>{question?.['subQuestions'].map((subQuestion, subIdx) => {
																		return <div key={`subquestion-${question._id}-${subIdx}-${subQuestion['subQNo']}`}>
																			<p>{subQuestion['subQDescription']}</p>
																			<textarea defaultValue={question?.['answer']?.['subAnswers'] && question?.['answer']?.['subAnswers']?.[subQuestion['subQNo']]} rows="1" style={{ resize: "vertical" }} onBlur={(e) => saveAnswer(e, question, qNo)} name={subQuestion['subQNo']} type="text" className="pl1-5rem bss bw2px bo5 w100 br5px p1rem"
																				placeholder={`Please enter director LinkedIn url here`} ></textarea>
																		</div>
																	})}
																	</>
																	: <textarea defaultValue={answer.comment} rows="1" style={{ resize: "vertical" }} onBlur={(e) => saveAnswer(e, question, qNo)} name="comment" type="text" className="pl1-5rem bss bw2px bo5 w100 br5px p1rem"
																		placeholder={`Please enter director LinkedIn url here`} ></textarea>
																}
															</div>
															: <div className={(question?.questionType.includes("YN") && (showFiles ? "" : "op0 h0 dn ")) + "oyh td250 pr mt1rem"}>
																<textarea defaultValue={answer.comment} rows="3" style={{ resize: "vertical" }} onBlur={(e) => saveAnswer(e, question, qNo)} name="comment" type="text" className="pl1-5rem bss bw2px bo5 w100 br5px p1rem"
																	placeholder={`Any notes you wish to add`} ></textarea>
															</div>
														}</>
													}
												</div>
												: <div className={(showFiles ? "" : "op0 h0 dn ") + "showOrHide oyh td250 oxh p1rem px1-5rem br10px"} style={{ background: '#F3F5FF' }}>
													<div className="df aic jcsb mb0-5rem cp" onClick={() => setUploadOpenMap(prev => ({ ...prev, [question._id]: prev[question._id] !== false ? false : true }))}>
														<div className="df aic">
															<svg className='mr0-5rem' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																<g clipPath="url(#clip0_6001_294)"><path d="M4.85746 16.7168C2.75033 14.9386 2.60107 11.6378 4.52471 9.35828L9.75741 3.15748C10.9943 1.69173 13.1027 1.43054 14.4565 2.57298C15.8103 3.71542 15.9073 5.83769 14.6704 7.30344L9.68688 13.209C9.27425 13.6979 8.57252 13.7852 8.12052 13.4038C7.66853 13.0224 7.63658 12.316 8.04922 11.827L13.0327 5.92146C13.4454 5.43248 13.4123 4.72514 12.9614 4.34464C12.5105 3.96413 11.8077 4.05049 11.3951 4.53947L6.16237 10.7403C5.06301 12.043 5.14829 13.9289 6.35252 14.9451C7.55675 15.9613 9.43012 15.7283 10.5295 14.4256L17.2572 6.45311C17.6699 5.96414 18.3716 5.87685 18.8236 6.25828C19.2756 6.63971 19.3075 7.34612 18.8949 7.8351L12.1671 15.8076C10.2435 18.0871 6.96459 18.4949 4.85746 16.7168Z" fill="#4A67FF" /></g>
																<defs><clipPath id="clip0_6001_294"><rect width="20" height="20" fill="white" /></clipPath></defs>
															</svg>
															<p className="fs16px c14 fw400 mb0">Files <span className="fs14px c12">({answer.files ? answer.files.length : 0})</span></p>
														</div>
														<svg style={{ transition: 'transform 0.2s', transform: uploadOpenMap[question._id] !== false ? 'rotate(180deg)' : 'rotate(0deg)' }} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M6 9l6 6 6-6" stroke="#4A67FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
														</svg>
													</div>
													{uploadOpenMap[question._id] !== false && <label onDragOver={onDragOver} onDrop={(e) => onDrop(e, question, qNo)} htmlFor={"fileUpload" + question._id} className="w100 bg1 br10px df jcc fdc aic px2rem py0-5rem cp mb0-5rem" style={{ border: '2px dotted #d2d2d2' }}>
														<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M33.979 17.7398C33.4537 14.3775 30.5388 11.7969 27.0312 11.7969C25.7117 11.7969 24.4438 12.162 23.344 12.8429C21.6709 10.031 18.6588 8.28125 15.3125 8.28125C10.1432 8.28125 5.9375 12.487 5.9375 17.6562C5.9375 17.6883 5.9375 17.7215 5.93867 17.7535C2.61641 18.3131 0 21.2096 0 24.6875C0 28.5648 3.23211 31.7188 7.10938 31.7188H32.8906C36.7679 31.7188 40 28.5648 40 24.6875C40 21.1799 37.3413 18.2651 33.979 17.7398Z" fill="#F3F5FF" />
															<g clipPath="url(#clip0_6001_237u)">
																<path d="M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z" fill="#4A67FF" />
																<path d="M19.9952 28.3744C19.2845 28.3744 18.574 28.3744 17.8636 28.3744C16.8892 28.3744 16.1861 27.6738 16.1811 26.6997C16.1792 26.3597 16.1792 26.0196 16.1811 25.6794C16.183 25.3288 16.3955 25.1032 16.7205 25.1025C17.0455 25.1019 17.2608 25.326 17.263 25.6763C17.2652 26.0266 17.263 26.3688 17.263 26.715C17.2655 27.0782 17.4789 27.2897 17.8433 27.29C19.2827 27.29 20.7219 27.29 22.1611 27.29C22.5258 27.29 22.7395 27.0782 22.7423 26.7154C22.7448 26.3691 22.7423 26.0229 22.7423 25.6766C22.7423 25.3304 22.9583 25.1019 23.2845 25.1025C23.6108 25.1032 23.8264 25.3288 23.8236 25.6791C23.8202 26.1219 23.8448 26.5694 23.7892 27.0063C23.6873 27.8057 23.0058 28.37 22.197 28.3738C21.4648 28.376 20.7298 28.3744 19.9952 28.3744Z" fill="#F3F5FF" />
																<path d="M19.4627 21.4916C19.3802 21.5684 19.3317 21.6106 19.2867 21.6559C18.9405 22.0056 18.5961 22.3575 18.2483 22.7059C18.0014 22.9534 17.6573 22.9716 17.4342 22.755C17.2111 22.5384 17.2198 22.1831 17.4627 21.9387C18.1695 21.2275 18.8787 20.5188 19.5902 19.8125C19.8402 19.5625 20.167 19.5625 20.417 19.8125C21.1333 20.5229 21.8466 21.2364 22.557 21.9528C22.7908 22.1888 22.792 22.5434 22.5748 22.7553C22.3577 22.9672 22.0123 22.9578 21.7739 22.7213C21.4208 22.3697 21.073 22.0125 20.7223 21.6588C20.677 21.6131 20.6286 21.5706 20.5564 21.5025C20.5517 21.6006 20.5461 21.6641 20.5461 21.7275C20.5461 22.8459 20.5477 23.9641 20.5461 25.0825C20.5461 25.5022 20.1767 25.7519 19.7927 25.6025C19.5802 25.5197 19.4648 25.3353 19.4648 25.0653C19.4636 23.9591 19.4636 22.8529 19.4648 21.7469L19.4627 21.4916Z" fill="#F3F5FF" />
															</g>
															<defs><clipPath id="clip0_6001_237u"><rect width="16" height="16" fill="white" transform="translate(12 16)" /></clipPath></defs>
														</svg>
														<span className="op80 pen fs0-75rem fw400 c12 tac mt0-5rem fsi">Click here or drag and drop files (max 100MB)</span>
														<input onChange={(e) => saveAnswer(e, question, qNo)} className="dn" id={"fileUpload" + question._id} type="file" multiple />
													</label>}
													{uploadOpenMap[question._id] !== false && <>
														{answer.files && answer.files.length > 0 && <p className="fw500 c12 mt1rem fs0-75rem">Attached Files</p>}
														<div className="df fdc w100" style={{ maxHeight: '20vh', overflow: 'auto' }}>
															{answer.files && answer.files.map((file, fileIdx) => {
																let fileColor = file.originator == 'ai-report' ? 'ai-report' : file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${AppMode === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
																return (
																	<div key={`answer-file-${question._id}-${fileIdx}-${file.key || file.originalname}`} className="df aic py0-5rem bg1 px1rem br20px mt0-5rem" style={{ maxWidth: 'max-content' }}>
																		<div className="df aic cp" onClick={() => getViewableURL(file.location)}>
																			<span className={`br50px mr0-5rem ${fileColor}`} style={{ width: '10px', height: '10px', minWidth: '10px', flexShrink: 0 }} />
																			<span className="fw500 c14 fs12px">{file.originalname && file.originalname.length > 40 ? file.originalname.slice(0, 40) + '...' : file.originalname}</span>
																		</div>
																		<i className="fa fa-trash-o cp c23 ml3rem" onClick={e => { e.preventDefault(); setDeleteFileQuestionId(question._id); setDeleteFile(file); dispatch(toggleModal({ open: 'deleteFile', from: '' })) }} />
																	</div>)
															})}
														</div>
														<div className="oyh td250 pr df aic mt0-5rem">
															<textarea
																defaultValue={answer.comment}
																rows="1"
																style={{ resize: "vertical" }}
																onBlur={(e) => saveAnswer(e, question, qNo)}
																name="comment"
																type="text"
																placeholder="Add notes"
																className="pl3rem bss bw2px bo5 br10px w100 pr1rem py0-75rem fs12px c15"
															>
															</textarea>
														<svg className="pa ml1rem" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_5984_51771)">
																<path d="M14.25 8.25H9.75V3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75V8.25H3.75C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75H8.25V14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25V9.75H14.25C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25Z" fill="#4A67FF" />
																<g clip-path="url(#clip1_5984_51771)">
																	<path d="M16.7301 14.3415L4.73098 17.2387C4.09339 17.3926 3.45171 17.0005 3.29776 16.3629L0.400638 4.36379C0.246685 3.7262 0.638767 3.08452 1.27636 2.93057L13.2755 0.0334501C13.9131 -0.120503 14.5548 0.27158 14.7087 0.909168L17.6059 12.9083C17.7598 13.5459 17.3678 14.1876 16.7301 14.3415Z" fill="url(#paint0_linear_5984_51771)" />
																	<path d="M14.3672 14.9115L16.7313 14.3407C17.3688 14.1868 17.7609 13.5451 17.607 12.9075L15.3723 3.65234H14.3672V14.9115Z" fill="url(#paint1_linear_5984_51771)" />
																	<path d="M15.3863 3.72331L14.7068 0.909168C14.5529 0.271579 13.9112 -0.120503 13.2736 0.0334501L1.27447 2.93057C0.856593 3.03147 0.54424 3.34185 0.421875 3.72331H15.3863Z" fill="url(#paint2_linear_5984_51771)" />
																	<path d="M1.85156 10.3629L3.30014 16.3624C3.45409 17 4.09574 17.3921 4.73336 17.2382L16.7325 14.341C17.3701 14.1871 17.7622 13.5454 17.6082 12.9078L16.1597 6.9082L1.85156 10.3629Z" fill="url(#paint3_linear_5984_51771)" />
																	<path d="M11.3983 17.9993H1.36905C0.815741 17.9993 0.367188 17.5508 0.367188 16.9975L0.376011 3.92377C0.376011 3.37046 0.824564 2.92188 1.37787 2.92188H14.4486C15.0019 2.92188 15.4505 3.37043 15.4505 3.92377L15.4417 13.956C15.4417 16.1891 13.6314 17.9993 11.3983 17.9993Z" fill="url(#paint4_linear_5984_51771)" />
																	<path d="M8.50558 4.14062L7.3125 5.33371L10.9873 9.00846C11.5559 8.8328 12.0046 8.38404 12.1803 7.81538L8.50558 4.14062Z" fill="url(#paint5_linear_5984_51771)" />
																	<path d="M7.90614 5.57985C8.37206 5.57985 8.74977 5.20214 8.74977 4.73621C8.74977 4.27029 8.37206 3.89258 7.90614 3.89258C7.44021 3.89258 7.0625 4.27029 7.0625 4.73621C7.0625 5.20214 7.44021 5.57985 7.90614 5.57985Z" fill="url(#paint6_linear_5984_51771)" />
																	<path d="M0.367188 10.6563V16.9965C0.367188 17.5498 0.815741 17.9983 1.36905 17.9983H11.3983C13.6314 17.9983 15.4417 16.1881 15.4417 13.955V10.6562H0.367188V10.6563Z" fill="url(#paint7_linear_5984_51771)" />
																	<path d="M11.3984 17.9984V14.957C11.3984 14.4037 11.847 13.9551 12.4003 13.9551H15.4418C15.4418 16.1882 13.6315 17.9984 11.3984 17.9984Z" fill="url(#paint8_linear_5984_51771)" />
																	<path d="M13.0689 9.20312H7.28104C7.07404 9.20312 6.90625 9.37091 6.90625 9.57791C6.90625 9.78491 7.07404 9.9527 7.28104 9.9527H13.0689C13.2759 9.9527 13.4437 9.78491 13.4437 9.57791C13.4437 9.37091 13.2759 9.20312 13.0689 9.20312Z" fill="white" />
																	<path d="M2.74979 9.9527H4.44885C4.65585 9.9527 4.82364 9.78491 4.82364 9.57791C4.82364 9.37091 4.65585 9.20312 4.44885 9.20312H2.74979C2.54279 9.20312 2.375 9.37091 2.375 9.57791C2.375 9.78491 2.54279 9.9527 2.74979 9.9527Z" fill="white" />
																	<path d="M5.375 9.57791C5.375 9.78491 5.54279 9.9527 5.74979 9.9527H6.17455C6.38155 9.9527 6.54934 9.78491 6.54934 9.57791C6.54934 9.37091 6.38155 9.20312 6.17455 9.20312H5.74979C5.54282 9.20312 5.375 9.37091 5.375 9.57791Z" fill="white" />
																	<path d="M8.53764 10.9688H2.74979C2.54279 10.9688 2.375 11.1365 2.375 11.3435C2.375 11.5505 2.54279 11.7183 2.74979 11.7183H8.53764C8.74464 11.7183 8.91242 11.5505 8.91242 11.3435C8.91242 11.1365 8.74464 10.9688 8.53764 10.9688Z" fill="white" />
																	<path d="M13.066 10.9688H11.367C11.16 10.9688 10.9922 11.1365 10.9922 11.3435C10.9922 11.5505 11.16 11.7183 11.367 11.7183H13.066C13.273 11.7183 13.4408 11.5505 13.4408 11.3435C13.4408 11.1365 13.273 10.9688 13.066 10.9688Z" fill="white" />
																	<path d="M10.073 10.9688H9.64823C9.44123 10.9688 9.27344 11.1365 9.27344 11.3435C9.27344 11.5505 9.44123 11.7183 9.64823 11.7183H10.073C10.28 11.7183 10.4478 11.5505 10.4478 11.3435C10.4478 11.1365 10.28 10.9688 10.073 10.9688Z" fill="white" />
																</g>
															</g>
															<defs>
																<linearGradient id="paint0_linear_5984_51771" x1="4.64913" y1="5.97348" x2="20.2804" y2="15.518" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#D9B1EE" />
																	<stop offset="1" stop-color="#814AA0" />
																</linearGradient>
																<linearGradient id="paint1_linear_5984_51771" x1="16.8003" y1="9.28193" x2="15.1027" y2="9.28193" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#5B3374" stop-opacity="0" />
																	<stop offset="1" stop-color="#5B3374" />
																</linearGradient>
																<linearGradient id="paint2_linear_5984_51771" x1="7.90405" y1="1.33693" x2="7.90405" y2="3.53614" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#5B3374" stop-opacity="0" />
																	<stop offset="1" stop-color="#5B3374" />
																</linearGradient>
																<linearGradient id="paint3_linear_5984_51771" x1="10.1943" y1="13.541" x2="11.0307" y2="17.0005" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#5B3374" stop-opacity="0" />
																	<stop offset="1" stop-color="#5B3374" />
																</linearGradient>
																<linearGradient id="paint4_linear_5984_51771" x1="0.973999" y1="3.52579" x2="14.9207" y2="17.4724" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FFDD00" />
																	<stop offset="1" stop-color="#FFB000" />
																</linearGradient>
																<linearGradient id="paint5_linear_5984_51771" x1="9.96461" y1="6.7927" x2="5.00606" y2="1.83419" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FEA613" stop-opacity="0" />
																	<stop offset="1" stop-color="#E94444" />
																</linearGradient>
																<linearGradient id="paint6_linear_5984_51771" x1="7.37934" y1="4.20938" x2="8.24118" y2="5.07123" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FE93BB" />
																	<stop offset="1" stop-color="#FD3581" />
																</linearGradient>
																<linearGradient id="paint7_linear_5984_51771" x1="7.90442" y1="15.5917" x2="7.90442" y2="19.8029" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FEA613" stop-opacity="0" />
																	<stop offset="1" stop-color="#E94444" />
																</linearGradient>
																<linearGradient id="paint8_linear_5984_51771" x1="12.3144" y1="14.8711" x2="14.6838" y2="17.2404" gradientUnits="userSpaceOnUse">
																	<stop stop-color="#FFDD00" />
																	<stop offset="1" stop-color="#FFB000" />
																</linearGradient>
																<clipPath id="clip0_5984_51771">
																	<rect width="18" height="18" fill="white" />
																</clipPath>
																<clipPath id="clip1_5984_51771">
																	<rect width="18" height="18" fill="white" />
																</clipPath>
															</defs>
														</svg>
														</div>
													</>
													}
												</div>
											}
										</>}
										</div>
									</div>
								</div>
							);
						})}
						{showSubFolder && (
							<div className="toggleHeight cp">
								<div className="oh dg" style={{ cursor: "auto" }}>
									<div></div> {/*LEAVE EMPTY DIV HERE*/}

									{getSectionHTML(module, section)}
								</div>
							</div>
						)}
					</>;
					return (
						<div ref={(el) => { if (section['sectionNo']) sectionRefs.current[sectionIdx] = el }} key={`${module.type}-${sectionId}-${qNo}-${sectionIdx}`} id={qNo}
							className={(section['sectionNo'] && "sectionWrapper ") + " bss bw2px bo31 br10px px1rem py1rem mb0-5rem fs1rem"}>
							<div className="df mb0-5rem jcsb">
								<div className="df aic" style={{ gap: '0.75rem', flexWrap: 'wrap' }}>
									<h3 className="fs1rem mr0-5rem c15">
										<span className="fw400">{section['sectionName'] && `Section ${sectionIdx + 1}: `} </span>{section['sectionName'] || section['name']}
									</h3>
									<span className={(section['sectionNo'] && "sectionTitle") + " fs0-75rem c15"}>{qNo}
										<span className="mx0-5rem"> | </span> {getCompletenessAndRiskHTML(module.type, section.stats, questions)}
									</span>
									{(() => {
										const reportData = getSectionReport(section, false, null);
										const accuracyRating = reportData?.validation?.accuracyRating;
										const hasAccuracyRating = accuracyRating !== undefined && accuracyRating !== null && !Number.isNaN(Number(accuracyRating));
										return hasAccuracyRating ? (
											<div className="df aic jcc"
												style={{
													padding: '4px 10px', borderRadius: '10px', fontWeight: '600', fontSize: '0.75rem', height: '24px', lineHeight: '1',
													background: accuracyRating >= 7 ? '#e8f5e9' : accuracyRating >= 5 ? '#fff3e0' : '#ffebee',
													color: accuracyRating >= 7 ? '#1b5e20' : accuracyRating >= 5 ? '#e65100' : '#c62828',
													border: `1px solid ${accuracyRating >= 7 ? '#c8e6c9' : accuracyRating >= 5 ? '#ffe0b2' : '#ffcdd2'}`
												}}>
												Accuracy: {accuracyRating}/10
											</div>
										) : null;
									})()}
								</div>
								{section['isPrompt'] ? (() => {
									// Check if section has at least one file
									const hasFiles = section.questions.some(q => q.answer?.files && q.answer.files.length > 0) && section?.['stats']?.['completionPercent'] === 100;
									const currentKey = getReportGenerationKey(section, false);
									const isGenerating = reportGenerateLoading === currentKey;
									const isAnyGenerating = reportGenerateLoading !== null;
									return (
										<div className="df aic jcc" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
											<button type='button' disabled={isAnyGenerating || !hasFiles} onClick={() => hasFiles ? generateInsuranceAiReport({ data: section, isQuestion: false }) : ""} style={{ height: '40px' }}
												data-tooltip={hasFiles ? "" : "Complete the 100% section to generate the report"} className={`fs14px px1rem br20px cp c1 py0-25rem ${hasFiles && !isAnyGenerating ? 'bg3 bg3-hover' : 'bg5 c15 op50'} `}>
												{isGenerating ? "Generating..." : "Generate Report"}
											</button>
											<Link to={hasSectionReport(section, false, null) ? `#${getSectionTabName(section, false, null)}` : "#repository"}
												onClick={(e) => {
													if (isAnyGenerating) {
														e.preventDefault();
														return;
													}
													handleSectionReportLinkClick(e, section, false, null);
												}}
												className={`cp p1rem c1 ${hasSectionReport(section, false, null) && !isAnyGenerating ? 'bg3 bg3-hover' : 'bg5 c15 op50'} br50px fw400 fs14px zi0 td250 df aic jcc`} style={{ width: '40px', height: '40px', pointerEvents: isAnyGenerating ? 'none' : 'auto', cursor: isAnyGenerating ? 'not-allowed' : 'pointer' }}>
												R
											</Link>
										</div>
									);
								})() : null
								}

								{/* Auto-fill button for main section only (not sub-sections like D001.1) */}
								{!isTwoMinuteTesHomePage && section?.stats?.completionPercent < 100 &&
									qNo && !qNo.includes('.') && (
										<AutoFillButton
											companyId={companyId}
											moduleType={module.type}
											sectionCode={qNo}
											scope="section"
											size="small"
											onComplete={() => {
												reloadModule && reloadModule(tab);
											}}
										/>
									)}

								{/* {showSubFolder && <>{!module['expansionPack'] && <button className="td250 fs0-75rem pen bg5 c6 br5px fw600 px0-5rem py0-5rem"></button>Hide Subfolders</button>}</>} */}
							</div>
							{module.type === "business-audit" ? (
								<div className="toggleHeight cp">
									<button className="mb0-5rem td250 fs0-75rem pen bg5 c6 br5px fw600 px0-5rem py0-5rem">Show Section</button>
									<div className="oh dg" style={{ cursor: "auto", height: "0px" }}>
										<div></div>
										{jsx}
									</div>
								</div>)
								: <div className="dg">{jsx}</div>}
						</div>
					);
				})
			}
			{((user['role'] == 'Guest' || !user.firstName) && module['type'] == `two-minute-test-${company['testType']}`) &&
				<div className="maw400px mxa my2rem df jcc aic fdc">
					<Button
						btnType="warning"
						text="Next"
						disabled={(module?.['stats']?.['completionPercent'] != 100)}
						customClassName="df jcc aic"
						onClick={() => openKPI()}
					/>
				</div>
			}
		</>
	};

	return (
		<>
			<div className="td250 container bg1 py1rem w100 df">
				<div className="w80 mr1rem dg gg1rem">
					{/* Top Section */}
					{user?.role.toLowerCase() === "guest"
						? <HeadingSubheadingContent
							wrapperClass="tac"
							heading={company?.modules[tab]?.heading}
							subheading={company?.modules[tab]?.subheading}
							paragraph={isTwoMinuteTesHomePage
								? <>
									Register at the end of test to access more features <span className="fs11px">(No credit card required)</span>
									<br></br>
									<LockOutlined className="c3" />
								</>
								: <></>
							}
						/>
						: null
					}
					{tab !== 'investor-lead' && <div className="df aic jcsb btn-dataroom-saf pr">
						{/* Files Color List - left side */}
						{!isManualAdd && (
							<ul className="list-file-manger" style={{ marginBottom: "0px" }}>
								<li className="bg1 fw400 c2 upload-file">Uploaded Directly</li>
								<li className="bg1 fw400 c2 prepopulated-file">Companies House</li>
								<li className="bg1 fw400 c2 filing-assistant-file">AI Filing Assistant</li>
								<li className="bg1 fw400 c2 ai-report-file">AI Report</li>
								<li className="bg1 fw400 c2 sharepoint-file">Sharepoint</li>
								<li className="bg1 fw400 c2 dropbox-file">Dropbox</li>
								<li className="bg1 fw400 c2 gdrive-file">Drive</li>
							</ul>
						)}
						{isManualAdd && <p class='c15 fs1-5rem tac fw500 pb1rem'>Key Applicant Information</p>}
						{/* Buttons - right side */}
						<div className="df aic">
									{/* Dummy Buttons for 2-Minute from Home Page */}
									{isTwoMinuteTesHomePage && <>
										{/* 2-Minute Sync/View Data Room Buttons  */}
										<button disabled data-tooltip='Connect Data room feature is disabled. You must register to access it.' className='op50 cp bg1 c3 bw1px bo3 bss br50px fs0-75rem fw600 px0-75rem py0-5rem df jcc aic mr1rem'>
											Connect
											<span className="df ml0-5rem">
												<GoogleDrive className="pen fds w1rem ml0-5rem" />
												<Dropbox className="pen fds w1rem ml0-5rem" />
												<SharePoint className="pen fds w1rem ml0-5rem" />
											</span>
											&nbsp;&nbsp;&nbsp;
										</button>
										{/* 2-Minute Test Button Filling Assistant   */}
										<button data-tooltip='Filling Assistant feature is disabled. You must register to access it.' className='cp op50 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem fw600 df jcc aic fs0-75rem pr' disabled>
											{/* <img className="pa r0" style={{ top: "-15px" }} src={require("../../../../images/fillingassistanticons.png")} alt="fillingIcons" /> */}
											Filing Assistant
											<LockOutlined style={{ color: "#4A67FF", marginLeft: "8px", fontSize: '12px' }} />
										</button>
									</>}
									{tab === "kitemark" ? <>
										<span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Audit</span>
										<span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Report</span>
										<span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Digital Certificate</span>
										<span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Full Report</span>
										<span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Report by Section</span>
									</>
										: company.modules?.[tab] && tab === "repository" && (() => {
											const [syncLink, driveName] = company.gDriveLink ? [company.gDriveLink, "Google Drive"]
												: company.sharePointLink ? [company.sharePointLink, "SharePoint"]
													: company.dropBoxLink ? [company.dropBoxLink, "DropBox"]
														: [undefined, "Not Connected"];

											let syncRequired = false;
											const allFiles = [];
											// Collect all files
											const sections = company?.modules?.[tab]?.sections ?? [];
											for (const sec of sections) {
												const questions = sec?.questions ?? [];
												for (const ques of questions) {
													const files = ques?.answer?.files ?? [];
													if (files.length > 0) allFiles.push(...files);
												}
											}
											// Check if all files belong to the connected data room
											if (company.dropBoxFolderMetadata) syncRequired = allFiles.some((file) => !file?.dbFileMetadata);
											if (company.sharePointLink) syncRequired = allFiles.some((file) => !file?.spDriveItem)

											let disableSyncButton = true
											if (syncRequired === true) disableSyncButton = false

											const isMember = company['members']?.some(member => member._id === user._id) || company?.['advisors']?.[user._id];
											const hasAllPermissions = company ? hasAllDataRepoPermission(company?.['memberPermissions']?.[user._id]) || hasAllDataRepoPermission(company?.['advisors']?.[user._id]?.['modules']) : false;
											const isInvestorOwner = company?.['investors'] && Object.keys(company['investors']).length > 0 && company['investors'][user._id] && hasAllDataRepoPermission(company?.['investors']?.[user._id]?.['modules']);
											return <>
												{((!company?.isParent && company['owners'][0] === user._id) || (company?.isParent && company['owners'][0] === user._id) || (((company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id)) || (isMember && hasAllPermissions) || isInvestorOwner)
													? <div className="pr menuHover1">
														{tab == 'repository' && (
															syncLink == undefined &&
															<>
																<button onClick={() => dispatch(toggleModal({ open: 'connectDataroom' }))} className={`${!company['uploadedFile'] && 'op20 pen '} cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem mr0-5rem df jcc aic`}>
																	Connect
																	<span className="df ml0-5rem">
																		<GoogleDrive className="pen fds w1rem ml0-5rem" />
																		<Dropbox className="pen fds w1rem ml0-5rem" />
																		<SharePoint className="pen fds w1rem ml0-5rem" />
																	</span>
																</button>
															</>
														)}
													</div>
													: <div></div>
												}
												{/* Auto-fill All Button */}
												{!isTwoMinuteTesHomePage && !isManualAdd && company?.['modules']?.[tab]?.['stats']?.['completionPercent'] < 100 && (
													<AutoFillButton companyId={companyId} moduleType={tab} scope="module" size="medium"
														onComplete={() => { reloadModule && reloadModule(tab); }}
													/>
												)}
												{/* Three Dots Dropdown */}
												{tab == 'repository' && (
													<div className="pr menuHover">
														<button className="shadow cp bg1 br50px w2rem h2rem df jcc aic mr0-5rem">
															<span class='fs1-5rem fw600 c3 mb1rem'>...</span>
														</button>
														<div className="menu op0 pen zi10 bg1 br10px shadow pa r0 df fdc" style={{ minWidth: '220px' }}>
															<div
																className="pr sub-menuHover"
																onMouseEnter={() => setFilingAssistantSubmenuHover(true)}
																onMouseLeave={() => setFilingAssistantSubmenuHover(false)}
															>
																<p className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb" style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
																	<img src={require('../../../../images/filing-assistant-icon.png')} alt="filing-assistant-icon" />
																	Filing Assistant
																	<span className="c3 ml0-5rem">&gt;</span>
																</p>
																<div className={`sub-menu zi10 bg1 br10px shadow pa t0 df fdc ${filingAssistantSubmenuHover ? 'op1 pea' : 'op0 pen'}`} style={{ minWidth: '250px', left: '100%' }}>
																	<p onClick={onAccurateFileName} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb" style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>Import Files</p>
																	<p onClick={onAccurateFolderName} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">Import Folders</p>
																	{(company['subscription'] && company['subscription'].toLowerCase() === "pro") && <p onClick={onClickFileReportHistory} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">Filing Assistant Manager</p>}
																	<p onClick={onClickViewUnallocatedFiles} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">View Unallocated Files</p>
																	<p onClick={() => checkDuplicatedFiles()} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">Deduper</p>
																	<p onClick={onClickDeduperReportHistory} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb" style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>Deduper Reports</p>
																</div>
															</div>
															<hr class='c16 fw100' />
															{syncLink == undefined
																? <>
																	<p className="op50 df w100 bg5-hover c14 px1rem py0-5rem cna"><span className="df"><GoogleDrive className="pen fds w1rem mr0-5rem" /></span>Data Room</p>
																	<p className="op50 df aic w100 bg5-hover c14 px1rem py0-5rem cna"><img class="mr0-5rem" src={require('../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room</p>
																</>
																: <>
																	{/* GoogleDrive */}
																	{company.gDriveLink && <>
																		{company['folderId'] &&
																			<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
																				<button disabled={syncing} onClick={() => openWindow(`https://drive.google.com/drive/folders/${company['folderId']}`)} class={`cp df ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																					<span className="df"><GoogleDrive className="pen fds w1rem mr0-5rem" /></span>Data Room
																				</button>
																			</p>
																		}
																		<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
																			<button disabled={syncing} onClick={() => syncDrive()} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																				<img class="mr0-5rem" src={require('../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
																			</button>
																		</p>
																		<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
																			<button disabled={syncing} onClick={() => handleDisconnectDataRoom("gdrive")} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																				<i class="fa fa-unlink c4 mr0-5rem" />Disconnect
																			</button>
																		</p>
																	</>}
																	{/* Dropbox */}
																	{company.dropBoxLink && <>
																		{company['dropBoxFolderMetadata'] &&
																			<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
																				<button disabled={syncing} onClick={() => openWindow(`https://dropbox.com/home/${company['dropBoxFolderMetadata']['path_display']}`)} class={`cp df ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																					<span className="df"><Dropbox className="pen fds w1rem mr0-5rem" /></span>Data Room
																				</button>
																			</p>
																		}
																		<p className={`${(company['syncRequired'] || syncRequired) ? 'op100' : 'op60'} cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`}>
																			<button disabled={(syncing || disableSyncButton)} onClick={() => syncDropbox()} class={`${(company['syncRequired'] || syncRequired) ? 'op100' : 'op60'} cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																				<img class="mr0-5rem" src={require('../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
																			</button>
																		</p>
																		<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company['syncRequired'] || syncRequired) && 'op60 cnd'}`}>
																			<button onClick={() => reverseSyncDropbox()} class={`cp df aic ${(syncing || company['syncRequired'] || syncRequired) && ''}`} style={{ background: 'transparent' }}>
																				<img class="mr0-5rem" src={require('../../../../images/sync-data-room.png')} alt="sync-data-room" />Reverse Sync
																			</button>
																		</p>
																		<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
																			<button disabled={syncing} onClick={() => handleDisconnectDataRoom("dropbox")} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																				<i class="fa fa-unlink c4 mr0-5rem" />Disconnect
																			</button>
																		</p>
																	</>}

																	{/* SharePoint */}
																	{company.sharePointLink && <>
																		{company['sharePointFolderDriveItem']?.['rootFolder']?.['webUrl'] &&
																			<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
																				<button disabled={syncing} onClick={() => openWindow(`${company['sharePointFolderDriveItem']['rootFolder']['webUrl']}`)} class={`cp df ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																					<span className="df"><SharePoint className="pen fds w1rem mr0-5rem" /></span>Data Room
																				</button>
																			</p>
																		}
																		<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`}>
																			<button disabled={(syncing || disableSyncButton)} onClick={() => syncSharePoint()} class={`cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																				<img class="mr0-5rem" src={require('../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
																			</button>
																		</p>
																		<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company['syncRequired'] || syncRequired) && 'op60 cnd'}`}>
																			<button disabled={syncing || company['syncRequired'] || syncRequired} onClick={() => reSyncSharePoint()} class={`cp df aic ${(syncing || company['syncRequired'] || syncRequired) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																				<img class="mr0-5rem" src={require('../../../../images/sync-data-room.png')} alt="sync-data-room" />Reverse Sync
																			</button>
																		</p>
																		<p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
																			<button disabled={syncing} onClick={() => handleDisconnectDataRoom("sharepoint")} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
																				<i class="fa fa-unlink c4 mr0-5rem" />Disconnect
																			</button>
																		</p>
																	</>}
																</>
															}
															<hr class='c16 fw100' />
															<p className="df aic w100 bg5-hover c14 px1rem py0-5rem cp" style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
																	<img src={require("../../../../images/double-star-icon.png")} alt="double-star-icon" className="w20px h20px mr0-5rem" />
																	Analyse All
																</p>
														</div>
													</div>
												)}
												{/* Filing Assistant */}
												{/* {tab == 'repository' && (<>
													<div className="pr df jce aifs">
														<div className="menuHover pr h100">
															<button onMouseEnter={() => setFAMenuVisible(true)} className="w200px btn-filing-assistant bg3 bg4-hover c1 td250 br50px px1rem py0-5rem h100 fw600 cp ttc bsbb tac df jcc aic fs13px">
																<span className="tooltip-area" style={{ top: '0px', left: '0px' }}>
																	<i className="icon pr">
																		<img className="h3rem" src={require(`../../../../images/info-icon.svg`)} alt="info-icon" />
																		<div className="overlay-box withGirl"></div>
																	</i>
																</span>
																Filing Assistant
															</button>
															{isFAMenuVisible && (
																<div className="miw100 menu op0 bsbb bw0px bbw5px bss bo3 zi1 bg1 shadow td250 pen p0-5rem pa t100 r0 df fdc">
																	<label onClick={onAccurateFileName} className="bsbb wsn w100 td250 c4-hover p0-5rem ass cp">
																		<span>Import Files</span>
																	</label>
																	<label onClick={onAccurateFolderName} className="bsbb w100 wsn td250 c4-hover p0-5rem ass cp">
																		<span>Import Folders</span>
																	</label>
																	{company['subscription'] && company['subscription'].toLowerCase() === "pro"
																		? <p onClick={onClickFileReportHistory} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">Filing Assistant Manager</p>
																		: null
																	}
																	<p onClick={onClickViewUnallocatedFiles} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">View Unallocated Files</p>
																	<p onClick={() => checkDuplicatedFiles()} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">Deduper</p>
																	<p onClick={onClickDeduperReportHistory} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">Deduper Reports</p>
																</div>
															)}
														</div>
													</div>
												</>)} */}
											</>
										})()
									}
						</div>
					</div>}
							{/* Last Synced By  */}
							{tab !== 'investor-lead' && tab === "repository" && ((!company?.isParent && company['owners'][0] === user._id) || (company?.isParent && company['owners'][0] === user._id) || ((company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id)) && <>
								<div className="dg gtcr2-md gg0-5rem">
									{company['lastSyncBy'] && company.modules?.[tab]?.uploadFiles &&
										<div className="df aic fs14px c15">
											{company['syncRequired'] && <span className="c4">* Sync is Required -  </span>}
											Last synced by - {company?.['lastSyncBy']?.['profile'] && <img className={`ass mx0-5rem br100 w2rem h2rem`} src={company?.['lastSyncBy']?.['profile']} />} {company?.['lastSyncBy']?.['firstName']},
											{moment(company['lastSyned']).format('lll')}
										</div>
									}
								</div>
							</>}
			

					{/* QuesAns Section */}
					{company?.modules[tab] && getSectionHTML(company.modules[tab])}

					{/* Bottom Section */}
					{(isManualAdd && tab == 'investor-lead') &&
						<div class='df jcc mt1rem'>
							<button onClick={() => company?.['modules']?.[tab]?.['stats']?.['completionPercent'] && dispatch(toggleModal({ open: 'addingApplicantManual' }))} data-tooltip={company?.['modules']?.[tab]?.['stats']?.['completionPercent'] < 99 ? 'Please complete the questionnaire' : ''}
								disabled={company?.['modules']?.[tab]?.['stats']?.['completionPercent'] < 99} className={`c1 br20px px4rem py0-5rem mb1rem fw500 tac ${(company?.['modules']?.[tab]?.['stats']?.['completionPercent'] < 99) ? 'cna bg16' : 'cp bg4'}`} >
								Next
							</button>
						</div>
					}
					{tab == 'repository' &&
						<div className="py2rem df jcc gg1rem">
							<div>
								<button className={`${(company?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`} onClick={(e) => toggleReport(e)}>
									{tab.endsWith("-report") ? "Close" : "View"}{' Report'}
								</button>
							</div>
						</div>
					}
					{tab == 'business-audit' &&
						<div className="py2rem df jcc">
							<button onClick={() => enableAIEnhancedReporting()} className={`${(company?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} h100 mt0-5rem mxa shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`}>
								<svg className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path className="fa-primary" d="M339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z" /><path className="fa-secondary" d="M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z" /></svg>
								AI Enhanced Report
							</button>
						</div>
					}
					{(tab == 'warranty-disclosure' || tab == 'software-development') &&
						<div className="py3rem df jcc">
							<button className={`${(company?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`} onClick={() => toggleReport()}>
								{tab.endsWith("-report") ? "Close" : "View"}
								{tab == 'warranty-disclosure'
									? ' Disclosure Schedule'
									: ' Report'
								}
							</button>
						</div>
					}
				</div>

				{company?.modules[tab] && <SidebarIndex isManualAdd={isManualAdd} setIsWorkflowReport={setIsWorkflowReport} visibleSection={visibleSection} setTab={setTab} profileClass={profileClass} advisors={advisors} permissionLevel={permissionLevel} company={company} setCompany={setCompany} tab={tab} sanitiseTab={sanitiseTab} toggleReport={toggleReport} openKPI={openKPI} calculateStats={calculateStats}
					calculateSubFolderStats={calculateSubFolderStats} getCompletenessAndRiskHTML={getCompletenessAndRiskHTML} setSection={setSection} getViewableURL={getViewableURL} twoMinuteTestAIReport={twoMinuteTestAIReport} isTwoMinuteTesHomePage={isTwoMinuteTesHomePage} getFitInvestorFirms={getFitInvestorFirms} setOpenTabs={setOpenTabs} openTabs={openTabs} sortSections={sortSections}
					handleSuperflowNext={handleSuperflowNext} setCompanyDashboardTab={setCompanyDashboardTab} setTabName={setTabName} closeTab={closeTab} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} isLoader={isLoader} setIsLoader={setIsLoader} isExternalPage={false} />
				}
			</div>

			{/* Loading report generate */}

			{reportGenerateLoading && (
				<div className="df jcc aic pf l0 b0 bg1 p2rem br20px shadow" style={{ maxWidth: '450px', margin: '0 auto 0 90px', zIndex: '1000' }}>
					<div className="loading-report-generate">
						<div className="df aic jcc ">
							<img width={50} className="mr1-5rem" src={require('../../../../images/reportLoader/left.png')} alt="loading-report-left" />
							<img width={50} className="mr1rem infinite-rotate" src={require('../../../../images/reportLoader/center.png')} alt="loading-report-center" />
							<img width={50} src={require('../../../../images/reportLoader/right.png')} alt="loading-report-right" />
						</div>

						{/* <p className="fs1rem fw500 c15 tac my1rem fsi">100%</p> */}
						<p className="fs14px fw400 c37 tac mt1rem">Report being generated - please continue other tasks - we will let you know when report complete</p>
					</div>
				</div>
			)
			}

			{/* File Report History */}
			<FileReportHistory
				modalType={'fileReportHistory'}
				reportHistories={reportHistories}
				setFileReport={setFileReport}
				setCloneImportResult={setCloneImportResult}
				setCurrentScore={setCurrentScore}
				company={company}
				profileClass={profileClass}
			/>

			{/* File Report History */}
			<DisconnectDataroom
				tab={tab}
				modalType={'disconnectDataRoom'}
				companyId={company['_id']}
			/>

			{/* Unallocated Files */}
			<UnallocatedFilesModal
				modalType={'unallocatedFiles'}
				tab={tab}
				loading={loading}
				setLoading={setLoading}
				company={company}
				setUnallocatedFiles={setUnallocatedFiles}
				onClickUnallocatedBinAuditLog={onClickUnallocatedBinAuditLog}
				unallocatedFiles={unallocatedFiles}
				handleEditDispatch={handleEditDispatch}
				moveUnallocatedFile={moveUnallocatedFile}
				setDeleteUnallocatedFile={setDeleteUnallocatedFile}
				targetSection={targetSection}
			/>

			{/* Manage Files */}
			<ManageFilesModal
				modalType={'manageFiles'}
				reloadModule={reloadModule}
				section={section}
				setSection={setSection}
				company={company}
				getViewableURL={getViewableURL}
				handleEditDispatch={handleEditDispatch}
				setDeleteFileQuestionId={setDeleteFileQuestionId}
				setDeleteFile={setDeleteFile}
				tab={tab}
				targetSection={targetSection}
			/>

			<WarrantyDisclosureManageFilesModal
				modalType={'manageWarrantyDisclosureFiles'}
				reloadModule={reloadModule}
				section={section}
				setSection={setSection}
				company={company}
				getViewableURL={getViewableURL}
				handleEditDispatch={handleEditDispatch}
				setDeleteFileQuestionId={setDeleteFileQuestionId}
				setDeleteFile={setDeleteFile}
				tab={tab}
				targetSection={targetSection}
			/>

			{/* Duplication Check Waiting  */}
			<DeduperReportWaiting
				modalType={'checkingDuplication'}
				company={company}
				onClickDeduperAuditLog={onClickDeduperAuditLog}
			/>

			{/* File Deduplication Summary */}
			<DeduperReport
				modalType={'duplicationCheckSummary'}
				company={company}
				dupCheck={dupCheck}
				modal={modal}
				profileClass={profileClass}
				onClickDeduperAuditLog={onClickDeduperAuditLog}
				getViewableURL={getViewableURL}
				handleEditDispatch={handleEditDispatch}
				setRefresh={setRefresh}
				reloadModule={reloadModule}
				moveDeduperFile={moveDeduperFile}
				tab={tab}
			/>

			{/* Allocating Files Modal - moved to Popups.js for global access */}

			{/* Connect Dataroom */}
			<ConnectDataroomModal company={company} />

			{/* Pro Add Section */}
			<UserDefinedSectionModal
				onEdit={onEdit}
				onDelete={onDelete}
				modalType={'proaddsection'}
				editSectionName={editSectionName}
				additionalSections={additionalSections}
				isSectionNameDuplicate={isSectionNameDuplicate}
				onSaveAdditionalSections={onSaveAdditionalSections}
			/>

			{/* Delete File */}
			<DeleteFileConfirmModal
				modalType="deleteFile"
				deleteFile={deleteFile}
				onConfirm={() => confirmDeleteFile(modal['from'])}
				onCancel={() => dispatch(toggleModal({ open: modal['from'] }))}
			/>

			{/* Delete Unallocated File */}
			<DeleteFileConfirmModal
				modalType="deleteUnallocatedFile"
				deleteFile={deleteUnallocatedFile?.file ?? {}}
				onConfirm={confirmDeleteUnallocatedFile}
				onCancel={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))}
			/>

			{/* Audit Log */}
			<AuditLogModal
				getViewableURL={getViewableURL}
				profileClass={profileClass}
				modalType={"auditLog"}
				logList={logList}
				logModule={logModule}
				tab={tab}
			/>

			{/* Deduper Report Audit Log */}
			<Modal open={modal['open'] == 'deduperReportAuditLog'} onClose={() => dispatch(toggleModal({ open: 'duplicationCheckSummary' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<span className="pa t0 l0 m1rem ttc c7 fs1-5rem fw500">{company.subscription}</span>
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: 'duplicationCheckSummary' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac">{company['cName']} Audit Log</h1>
					<h2 className="c4 fs0-75rem ttc w100 tac mb1rem">See the history of Company Deduper Report</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						{logList.length > 0
							? getDeduperReportLogsHTML(logList)
							: <h2 className="c4 fs1-50rem ttc w100 tac mb1rem">No Logs Found!!</h2>
						}
					</div>
					<div className="df w100 fdr jcc ">
						<button onClick={() => dispatch(toggleModal({ open: 'duplicationCheckSummary' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic">Go Back</button>
					</div>
				</div>
			</Modal>

			{/* Unallocated Bin Audit Log */}
			<Modal open={modal['open'] == 'unallocatedBinAuditLog'} onClose={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<span className="pa t0 l0 m1rem ttc c7 fs1-5rem fw500">{company.subscription}</span>
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac">{company['cName']} Audit Log</h1>
					<h2 className="c4 fs0-75rem ttc w100 tac mb1rem">See the history of Company Unallocated Bin</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						{logList.length > 0
							? getUnallocatedBinLogsHTML(logList)
							: <h2 className="c4 fs1-50rem ttc w100 tac mb1rem">No Logs Found!!</h2>
						}
					</div>
					<div className="df w100 fdr jcc ">
						{/* <button onClick={() => dispatch(toggleModal({ open: '' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic mr1rem">OK</button> */}
						<button onClick={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic">Go Back</button>
					</div>
				</div>
			</Modal>

			{/* File Report Audit Log */}
			<Modal open={modal['open'] == 'fileReportAuditLog'} onClose={() => dispatch(toggleModal({ open: 'importSummary' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<span className="pa t0 l0 m1rem ttc c7 fs1-5rem fw500">{company.subscription}</span>
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: 'importSummary' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac">{company['cName']} Audit Log</h1>
					<h2 className="c4 fs0-75rem ttc w100 tac mb1rem">See the history of Company File Import</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						{logList.length > 0
							? getFileReportLogsHTML(logList)
							: <h2 className="c4 fs1-50rem ttc w100 tac mb1rem">No Logs Found!!</h2>
						}
					</div>
					<div className="df w100 fdr jcc ">
						<button onClick={() => dispatch(toggleModal({ open: 'importSummary' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic">Go Back</button>
					</div>
				</div>
			</Modal>

			{/* Data Repository */}
			<WelcomToDashboardModal
				modalType={'dataRepository'}
				dispatch={dispatch}
				company={company}
				user={user}
			/>

			{/* Repository Completed */}
			<Modal open={modal['open'] == 'repositoryCompleted'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					<h1 className="text-gradient fw600 pb1rem">Congratulations!</h1>
					<div className="tac df fdc jcc aic tac">
						<p>Hello, {user.firstName}! 🎉</p>
						<p>Look at you, unstoppable force! 🚀 You've made your first pass at filling your Data Repository and have emerged victorious! Now, it's time to step into your next adventure:</p>
						<p>Unleash the magic of connectivity! Sync your Repository with your preferred provider Data Room. This will create an unbreakable bond between your treasures, keeping them safe and accessible anytime, anywhere. 🌐</p>
						{company.gDriveLink && <button className="shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic" onClick={() => { dispatch(toggleModal({ open: '' })); syncDrive() }}>
							<GoogleDrive className="pen fds w2rem mr1rem" />
							👉 Sync Now
						</button>}

						<p>Excited to see the fruits of your labor? View your Repository Report and bask in the glory of your progress. Every detail counts in this journey, and you've made a remarkable headway! 📈</p>
						<button onClick={e => { dispatch(toggleModal({ open: '' })); toggleReport(e); }} className="shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">👉 View Report</button>
						<p>Feeling ready for the next level? It's time to take on the Quick Business Audit questionnaire! Upon its completion, Diligentsia’s unaudited certification awaits. This prized possession will symbolize your company's readiness for any challenge ahead. 💼</p>
						{(() => {
							const [syncLink, driveName] = company.gDriveLink ? [company.gDriveLink, "Google Drive"]
								: company.sharePointLink ? [company.sharePointLink, "SharePoint"]
									: company.dropBoxLink ? [company.dropBoxLink, "DropBox"]
										: [undefined, "Not Connected"];
							return <>
								{company.gDriveLink && <div className="df my1rem">
									<button className={`${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`} onClick={() => syncDrive()}>
										<GoogleDrive className="pen fds w2rem" />
										&nbsp;&nbsp;&nbsp;
										Sync Data room
									</button>
									{company['folderId'] &&
										<button className="ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100" onClick={() => openWindow(`https://drive.google.com/drive/folders/${company['folderId']}`)}>
											<GoogleDrive className="pen fds w2rem" />
											&nbsp;&nbsp;&nbsp;
											View Data Room
										</button>
									}
								</div>}
								{company.dropBoxLink && <div className="df my1rem">
									<button className={`${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`} onClick={() => syncDropbox()}>
										<Dropbox className="pen fds w2rem" />
										&nbsp;&nbsp;&nbsp;
										Sync Data room
									</button>
									{company['dropBoxFolderMetadata'] &&
										<button className="ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100" onClick={() => openWindow(`https://dropbox.com/home/${company['dropBoxFolderMetadata']['path_display']}`)}>
											<Dropbox className="pen fds w2rem" />
											&nbsp;&nbsp;&nbsp;
											View Data Room
										</button>
									}
								</div>}
								{company.sharePointLink && <div className="df my1rem">
									<button className={`${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`} onClick={() => syncSharePoint()}>
										<SharePoint className="pen fds w2rem" />
										&nbsp;&nbsp;&nbsp;
										Sync Data room
									</button>
									{company['sharePointLink'] &&
										<button className="ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100" onClick={() => openWindow(`${company['sharePointFolderDriveItem']['rootFolder']['webUrl']}`)}>
											<SharePoint className="pen fds w2rem" />
											&nbsp;&nbsp;&nbsp;
											View Data Room
										</button>
									}
								</div>}
								{syncLink == undefined && (
									tab == 'repository' && <button onClick={() => dispatch(toggleModal({ open: 'connectDataroom' }))} className={`${!company['uploadedFile'] && 'op20 pen '} my1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`}>Connect Data Room</button>
								)}
							</>
						})()}
						<p>Remember, every adventure you undertake strengthens your fortress, builds your credibility, and takes your business one step closer to greatness. Keep conquering, {user['firstName']}! 👍</p>
					</div>
				</div>
			</Modal>

			{/* Created DataRoom */}
			<Modal open={modal['open'] == 'createdDataRoom'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic" >
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					<div className="tac my1rem">
						<p className="mb0-5rem">Good news!  Your Cloud Data<br />Room has now been created.<br />You can now sync.​</p>
					</div>
					<div className="df jcc">
						<button className="w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttc bsbb df jcc" onClick={() => { window.location.href = `/company/${companyId}#repository` }}>Let’s go!​</button>
					</div>
				</div>
			</Modal>


			{/* New Applicant Investor Manual */}
			<Modal id="addingApplicantManual" open={modal['open'] == 'addingApplicantManual'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className='df jcc oscy' style={{ maxHeight: '100vh' }}>
					<div className='mah90 oya bg1 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr'>
						<div class='w100 df fdc aic'>
							<img className="my1rem" src={require(`../../../../images/super-flow/complete-icon-popup.png`)} alt="" />
							<p class='c15 fs1-25rem fw500 my1rem'>Thank you for adding this applicant</p>
							<p class='c15 fs1rem fw300'>Your new applicant has been added and is ready for review.</p>
							<p class='c15 fs1rem fw300'>Return to InvestorMatch to see the company and its newly generated reports.</p>
						</div>
						<div class='w100 df jcc my3rem'>
							<Link to='/investor-dashboard#index?QualifiedLeads' onClick={() => localStorage.removeItem('isManualAdd')} className='df jcc cp px3rem py0-5rem c1 bg4 bg3-hover br35px fw400 fs1rem'>Return to InvestorMatch</Link>
						</div>
					</div>
				</div>
			</Modal>

			<DisclaimerModal
				modalType={'DisclaimerAIReportModal'}
				handleClose={handleAiReportDisclaimerClose}
				subTitle="This report is for guidance only."
				content="This Report has been prepared by Diligensia for the exclusive use of the named client. It is based on information provided as at the date of issue and is intended solely to assist in identifying risks and opportunities. This report was generated by AI and may be inaccurate.  You are urged to check all report content. Diligentsia accepts no responsibility or liability for any errors, omissions, or delays, nor for any actions taken in reliance on this report. The contents do not constitute legal or financial advice, and professional advice should always be sought. This report may not be relied upon by any third party to whom the report is shown and Diligensia accepts no duty of care or liability to any third party who may obtain access to it."
			/>

			<ModalWrapper
				modalType={'successAiReportGenerated'}
				customStyle={{ padding: '0px 0rem 2rem', maxWidth: '500px !important' }}
				onCloseHandler={() => handleToggleSuccessAiReportGeneratedModal(false)}
			>
				<div>
					<div className='px4rem'>
						<h3 className='c15 tal mt3rem'>AI report is ready.</h3>
						<p className='c15 tal fs0-875rem my1rem' style={{ lineHeight: '1.5', color: '#505050' }}>
							We’ve compiled your latest AI report. Review the insights now or come back whenever it suits you—your report will be waiting.
						</p>
						<div className='df jcc gg1rem fdcb-sm'>
							<Button
								style={{ width: '250px' }}
								customClassName='mt1rem bg2'
								text={'Go to Report'}
								onClick={() => handleToggleSuccessAiReportGeneratedModal(true)}
								btnType='warning'
							/>
							<Button
								style={{ width: '250px' }}
								customClassName='mt1rem bg5 c15'
								text={'Thanks, I will look later'}
								onClick={() => handleToggleSuccessAiReportGeneratedModal(false)}
								btnType='primary'
							/>
						</div>
					</div>
				</div>
			</ModalWrapper>

			{/* Auto-fill Progress Modal - moved to Popups.js for global access */}

			{/* Workflow Notes Modal */}
			{workflowModalData && (
				<WorkflowNotesModal
					open={true}
					onClose={() => setWorkflowModalData(null)}
					question={workflowModalData.question}
					section={workflowModalData.section}
					answer={workflowModalData.answer}
					user={user}
					company={company}
					module={workflowModalData.module}
					onAnswerUpdated={() => { reloadModule && reloadModule(tab); }}
				/>
			)}

		</>
	);
}